{
  "level": "bs03",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs03",
    "objects": "AREAS.E3:bs03.e3",
    "mesh": "TREES.E3:bs03.e3"
  },
  "spawn_point": {
    "position": [
      -3188.7211606302917,
      -4185.115832668817,
      1045.5451049804688
    ],
    "facing_rad": 0.0,
    "look_point": [
      -3188.7211606302917,
      -4085.1158326688173,
      1045.5451049804688
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3963.99951171875,
      -5045.98291015625,
      1021.5451049804688
    ],
    "bbox_max": [
      -1964.791748046875,
      -3868.839599609375,
      1402.623779296875
    ],
    "vertex_count": 1063,
    "vertices": [
      [
        -3266.245361328125,
        -4057.72998046875,
        1049.781005859375
      ],
      [
        -3200.484375,
        -3991.968994140625,
        1049.7808837890625
      ],
      [
        -3276.144775390625,
        -4067.62939453125,
        1049.781005859375
      ],
      [
        -3341.90576171875,
        -4133.39013671875,
        1049.7808837890625
      ],
      [
        -2708.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.5999755859375
      ],
      [
        -2654.999755859375,
        -4012.0,
        1052.623779296875
      ],
      [
        -3276.144775390625,
        -4067.62939453125,
        1049.781005859375
      ],
      [
        -3271.119384765625,
        -4072.65478515625,
        1052.623779296875
      ],
      [
        -3261.219970703125,
        -4062.75537109375,
        1052.623779296875
      ],
      [
        -3266.245361328125,
        -4057.72998046875,
        1049.781005859375
      ],
      [
        -3127.458984375,
        -3925.7841796875,
        1051.7156982421875
      ],
      [
        -3129.628662109375,
        -3921.113037109375,
        1049.7808837890625
      ],
      [
        -3120.0,
        -3911.484375,
        1045.7926025390625
      ],
      [
        -3120.0,
        -3926.160400390625,
        1052.623779296875
      ],
      [
        -3120.0,
        -3911.484375,
        1045.7926025390625
      ],
      [
        -3120.0,
        -3911.484375,
        1049.7808837890625
      ],
      [
        -3120.0,
        -3921.53564453125,
        1052.623779296875
      ],
      [
        -3127.458984375,
        -3925.7841796875,
        1051.7156982421875
      ],
      [
        -3120.0,
        -3926.160400390625,
        1052.623779296875
      ],
      [
        -3124.624755859375,
        -3926.160400390625,
        1052.623779296875
      ],
      [
        -3200.484375,
        -3991.968994140625,
        1049.7808837890625
      ],
      [
        -3140.59619140625,
        -3897.5,
        1040.0
      ],
      [
        -3140.59619140625,
        -3897.5,
        1040.0
      ],
      [
        -3120.0,
        -3889.142822265625,
        1043.461669921875
      ],
      [
        -3120.0,
        -3908.0,
        1048.7952880859375
      ],
      [
        -3120.0,
        -3889.142822265625,
        1043.461669921875
      ],
      [
        -3120.0,
        -3908.0,
        1048.7952880859375
      ],
      [
        -3341.90576171875,
        -4133.39013671875,
        1049.7808837890625
      ],
      [
        -3240.0,
        -3868.839599609375,
        1052.623779296875
      ],
      [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1042.7222900390625
      ],
      [
        -3250.399169921875,
        -3942.054443359375,
        1021.5451049804688
      ],
      [
        -3240.0,
        -3926.160400390625,
        1052.623779296875
      ],
      [
        -3266.293212890625,
        -3926.16015625,
        1052.623779296875
      ],
      [
        -3274.95361328125,
        -3917.5,
        1031.7159423828125
      ],
      [
        -3404.65380859375,
        -4022.341064453125,
        1052.623779296875
      ],
      [
        -3397.582763671875,
        -4029.412109375,
        1052.623779296875
      ],
      [
        -3404.65380859375,
        -4036.483154296875,
        1052.623779296875
      ],
      [
        -3397.582763671875,
        -4029.412109375,
        1052.623779296875
      ],
      [
        -3411.724853515625,
        -4029.412109375,
        1052.623779296875
      ],
      [
        -3404.65380859375,
        -4036.483154296875,
        1052.623779296875
      ],
      [
        -3404.65380859375,
        -4022.341064453125,
        1052.623779296875
      ],
      [
        -3411.724853515625,
        -4029.412109375,
        1052.623779296875
      ],
      [
        -3383.440673828125,
        -4001.1279296875,
        1052.623779296875
      ],
      [
        -3376.36962890625,
        -4008.198974609375,
        1052.623779296875
      ],
      [
        -3383.440673828125,
        -4015.27001953125,
        1052.623779296875
      ],
      [
        -3376.36962890625,
        -4008.198974609375,
        1052.623779296875
      ],
      [
        -3390.51171875,
        -4008.198974609375,
        1052.623779296875
      ],
      [
        -3383.440673828125,
        -4015.27001953125,
        1052.623779296875
      ],
      [
        -3383.440673828125,
        -4001.1279296875,
        1052.623779296875
      ],
      [
        -3390.51171875,
        -4008.198974609375,
        1052.623779296875
      ],
      [
        -3266.66943359375,
        -3925.783935546875,
        1051.715576171875
      ],
      [
        -3294.953125,
        -3897.500244140625,
        1040.0
      ],
      [
        -3120.0,
        -3908.0,
        1052.623779296875
      ],
      [
        -3120.0,
        -3887.0,
        1052.623779296875
      ],
      [
        -3120.0,
        -3887.0,
        1052.623779296875
      ],
      [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      [
        -3120.0,
        -3908.0,
        1052.623779296875
      ],
      [
        -3240.0,
        -3887.0,
        1052.623779296875
      ],
      [
        -3240.0,
        -3908.0,
        1052.623779296875
      ],
      [
        -3240.0,
        -3868.839599609375,
        1052.623779296875
      ],
      [
        -3240.0,
        -3887.0,
        1052.623779296875
      ],
      [
        -3240.0,
        -3908.0,
        1052.623779296875
      ],
      [
        -3240.0,
        -3926.160400390625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.971435546875,
        -4011.955322265625,
        1052.623779296875
      ],
      [
        -2652.997802734375,
        -4012.0,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1082.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1052.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1082.623779296875
      ],
      [
        -2589.23681640625,
        -4020.00439453125,
        1187.623779296875
      ],
      [
        -2354.91015625,
        -4155.29296875,
        1082.623779296875
      ],
      [
        -2354.909423828125,
        -4155.2939453125,
        1185.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2615.537109375,
        -4065.557373046875,
        1112.623779296875
      ],
      [
        -2615.536865234375,
        -4065.557373046875,
        1121.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1152.623779296875
      ],
      [
        -2682.318603515625,
        -4075.498291015625,
        1063.98681640625
      ],
      [
        -2671.367431640625,
        -4043.355712890625,
        1052.623779296875
      ],
      [
        -2636.4775390625,
        -4053.46728515625,
        1112.623779296875
      ],
      [
        -2631.958984375,
        -4056.075927734375,
        1121.623779296875
      ],
      [
        -2653.26416015625,
        -4012.0,
        1052.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2664.091552734375,
        -4022.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2910.0,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -3026.0,
        -3925.124267578125,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -2846.860595703125,
        -3905.65966796875,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -3026.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2845.2509765625,
        -3898.5556640625,
        1057.5999755859375
      ],
      [
        -2829.04638671875,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2829.04638671875,
        -3902.0,
        1052.623779296875
      ],
      [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      [
        -2998.0,
        -3902.0,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.678955078125,
        -3903.140869140625,
        1052.623779296875
      ],
      [
        -2660.6845703125,
        -4012.0,
        1057.5999755859375
      ],
      [
        -2685.525146484375,
        -4073.64697265625,
        1057.5999755859375
      ],
      [
        -2676.163330078125,
        -4057.431884765625,
        1057.5999755859375
      ],
      [
        -2739.973876953125,
        -4244.7236328125,
        1057.5999755859375
      ],
      [
        -2750.961181640625,
        -4247.66796875,
        1057.5999755859375
      ],
      [
        -2667.587646484375,
        -3974.7685546875,
        1057.5999755859375
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1057.5999755859375
      ],
      [
        -2667.587646484375,
        -3974.7685546875,
        1052.623779296875
      ],
      [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      [
        -2772.989501953125,
        -3913.915283203125,
        1052.623779296875
      ],
      [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1072.9744873046875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1072.9744873046875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1057.5999755859375
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1082.623779296875
      ],
      [
        -2823.6796875,
        -3903.140869140625,
        1185.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1057.5999755859375
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1082.623779296875
      ],
      [
        -2772.9892578125,
        -3913.915283203125,
        1185.623779296875
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2727.750732421875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2727.750732421875,
        -4054.818603515625,
        1139.873779296875
      ],
      [
        -2727.750732421875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2992.248779296875,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2991.970458984375,
        -4054.818603515625,
        1127.5999755859375
      ],
      [
        -2991.970458984375,
        -4054.818603515625,
        1137.623779296875
      ],
      [
        -2939.499755859375,
        -4081.514404296875,
        1137.623779296875
      ],
      [
        -2939.89990234375,
        -4081.310791015625,
        1108.123779296875
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1139.873779296875
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2714.248779296875,
        -4046.718505859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1137.623779296875
      ],
      [
        -2725.0498046875,
        -4048.234375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -2781.499755859375,
        -4019.513916015625,
        1137.623779296875
      ],
      [
        -2781.899658203125,
        -4019.310302734375,
        1108.123779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1139.873779296875
      ],
      [
        -2727.813720703125,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -2725.0498046875,
        -4048.234130859375,
        1127.5999755859375
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1057.5999755859375
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2794.96826171875,
        -4012.66162109375,
        1076.123779296875
      ],
      [
        -2796.9638671875,
        -4004.117919921875,
        1084.623779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1084.623779296875
      ],
      [
        -2792.34521484375,
        -4004.117919921875,
        1113.123779296875
      ],
      [
        -2796.75341796875,
        -4011.75341796875,
        1113.123779296875
      ],
      [
        -2800.323486328125,
        -4009.93701171875,
        1106.623779296875
      ],
      [
        -2796.9638671875,
        -4004.117919921875,
        1106.623779296875
      ],
      [
        -2857.65478515625,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2859.99951171875,
        -3979.57568359375,
        1069.623779296875
      ],
      [
        -2850.55126953125,
        -3974.7685546875,
        1069.623779296875
      ],
      [
        -2849.79296875,
        -3984.7685546875,
        1065.623779296875
      ],
      [
        -2857.65478515625,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2850.55126953125,
        -3974.7685546875,
        1069.623779296875
      ],
      [
        -2850.55126953125,
        -3974.7685546875,
        1057.5999755859375
      ],
      [
        -2802.53564453125,
        -4013.768310546875,
        1084.623779296875
      ],
      [
        -2800.22607421875,
        -4017.7685546875,
        1113.123779296875
      ],
      [
        -2802.53564453125,
        -4013.768310546875,
        1106.623779296875
      ],
      [
        -2939.89990234375,
        -4020.226318359375,
        1108.123779296875
      ],
      [
        -2939.499755859375,
        -4020.02294921875,
        1137.623779296875
      ],
      [
        -2870.206787109375,
        -3984.7685546875,
        1065.623779296875
      ],
      [
        -2862.34423828125,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2862.34423828125,
        -3980.7685546875,
        1069.623779296875
      ],
      [
        -2999.930908203125,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -2992.185791015625,
        -4046.827880859375,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1139.873779296875
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1100.8765869140625
      ],
      [
        -3434.203125,
        -4041.093017578125,
        1052.623779296875
      ],
      [
        -3301.525146484375,
        -3890.92822265625,
        1100.8765869140625
      ],
      [
        -3293.08740234375,
        -3899.365966796875,
        1052.623779296875
      ],
      [
        -3434.10791015625,
        -4041.188232421875,
        1052.623779296875
      ],
      [
        -3292.686279296875,
        -3899.76708984375,
        1052.623779296875
      ],
      [
        -3170.86669921875,
        -3902.59228515625,
        1302.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3121.341064453125,
        -3937.5,
        1080.0
      ],
      [
        -3120.0,
        -3930.11328125,
        1097.8330078125
      ],
      [
        -3193.48193359375,
        -3998.971435546875,
        1082.623779296875
      ],
      [
        -3196.198974609375,
        -3996.254638671875,
        1086.5999755859375
      ],
      [
        -3193.51171875,
        -3998.941650390625,
        1082.7830810546875
      ],
      [
        -3243.613525390625,
        -3948.83984375,
        1052.623779296875
      ],
      [
        -3264.324462890625,
        -3928.12890625,
        1102.623779296875
      ],
      [
        -3187.8642578125,
        -4004.589111328125,
        1052.623779296875
      ],
      [
        -3193.48193359375,
        -3998.971435546875,
        1082.623779296875
      ],
      [
        -3163.276611328125,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3136.854736328125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3147.131591796875,
        -3958.887451171875,
        1082.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      [
        -3122.400634765625,
        -3937.5,
        1082.623779296875
      ],
      [
        -3121.34130859375,
        -3937.5,
        1080.0001220703125
      ],
      [
        -3143.122314453125,
        -3937.5,
        1079.9998779296875
      ],
      [
        -3143.122314453125,
        -3937.5,
        1079.9998779296875
      ],
      [
        -3121.948486328125,
        -3940.84619140625,
        1071.921630859375
      ],
      [
        -3130.35986328125,
        -3947.0,
        1075.1307373046875
      ],
      [
        -3130.35986328125,
        -3947.0,
        1075.1307373046875
      ],
      [
        -3133.385498046875,
        -3947.0,
        1082.623779296875
      ],
      [
        -3124.059814453125,
        -3937.5,
        1086.732666015625
      ],
      [
        -3144.93017578125,
        -3950.0,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1102.623779296875
      ],
      [
        -3163.27734375,
        -3965.86669921875,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      [
        -3169.5,
        -3968.556396484375,
        1102.623779296875
      ],
      [
        -3137.0380859375,
        -3947.0,
        1091.66943359375
      ],
      [
        -3124.0595703125,
        -3937.5,
        1086.732666015625
      ],
      [
        -3160.0,
        -3950.0,
        1100.4039306640625
      ],
      [
        -3165.8359375,
        -3950.0,
        1102.623779296875
      ],
      [
        -3160.0,
        -3950.0,
        1100.4039306640625
      ],
      [
        -3144.93017578125,
        -3950.0,
        1102.623779296875
      ],
      [
        -3141.13671875,
        -3950.0,
        1093.228515625
      ],
      [
        -3150.0,
        -3956.48779296875,
        1096.5999755859375
      ],
      [
        -3142.498046875,
        -3950.0,
        1096.5999755859375
      ],
      [
        -3137.037841796875,
        -3947.0,
        1091.66943359375
      ],
      [
        -3136.854736328125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3150.0,
        -3956.48779296875,
        1096.5999755859375
      ],
      [
        -3150.0,
        -3960.0,
        1086.542236328125
      ],
      [
        -3140.0,
        -3950.0,
        1090.413330078125
      ],
      [
        -3140.0,
        -3952.719970703125,
        1082.623779296875
      ],
      [
        -3149.70458984375,
        -3960.0,
        1082.623779296875
      ],
      [
        -3150.0,
        -3960.0,
        1086.5421142578125
      ],
      [
        -3149.70458984375,
        -3960.0,
        1085.8109130859375
      ],
      [
        -3169.5,
        -3978.231689453125,
        1082.623779296875
      ],
      [
        -3191.206787109375,
        -3997.00390625,
        1082.623779296875
      ],
      [
        -3171.787353515625,
        -3980.2099609375,
        1082.623779296875
      ],
      [
        -3175.532470703125,
        -3976.46484375,
        1102.623779296875
      ],
      [
        -3171.787353515625,
        -3980.2099609375,
        1082.623779296875
      ],
      [
        -3169.5,
        -3978.231689453125,
        1082.623779296875
      ],
      [
        -3169.5,
        -3971.248046875,
        1102.623779296875
      ],
      [
        -3175.532470703125,
        -3976.46484375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3968.55615234375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3971.247802734375,
        1102.623779296875
      ],
      [
        -3169.5,
        -3971.248046875,
        1102.623779296875
      ],
      [
        -3163.277099609375,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3148.417724609375,
        -3960.0,
        1082.623779296875
      ],
      [
        -3191.206787109375,
        -3997.00390625,
        1082.623779296875
      ],
      [
        -3191.951416015625,
        -3996.25927734375,
        1086.5999755859375
      ],
      [
        -3196.198974609375,
        -3996.25439453125,
        1086.5999755859375
      ],
      [
        -3191.951416015625,
        -3996.25927734375,
        1086.5999755859375
      ],
      [
        -3193.11865234375,
        -3997.268798828125,
        1086.5999755859375
      ],
      [
        -3121.341064453125,
        -3937.5,
        1080.0
      ],
      [
        -3120.0,
        -3936.870849609375,
        1078.4808349609375
      ],
      [
        -3266.293212890625,
        -3926.16015625,
        1052.623779296875
      ],
      [
        -3254.953369140625,
        -3937.5,
        1080.0003662109375
      ],
      [
        -3117.37451171875,
        -3937.5,
        1070.176513671875
      ],
      [
        -3117.37451171875,
        -3937.5,
        1070.176513671875
      ],
      [
        -3120.0,
        -3936.870849609375,
        1078.4808349609375
      ],
      [
        -3120.0,
        -3930.11328125,
        1097.8330078125
      ],
      [
        -3108.0,
        -3923.657958984375,
        1086.5999755859375
      ],
      [
        -3098.0,
        -3915.010009765625,
        1086.5999755859375
      ],
      [
        -3089.89404296875,
        -3908.0,
        1086.5999755859375
      ],
      [
        -3088.0,
        -3906.362060546875,
        1086.5999755859375
      ],
      [
        -3088.0,
        -3908.0,
        1081.9095458984375
      ],
      [
        -3088.0,
        -3906.3623046875,
        1086.5999755859375
      ],
      [
        -3108.0,
        -3923.657958984375,
        1086.5999755859375
      ],
      [
        -3108.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      [
        -3108.0,
        -3877.0,
        1076.5999755859375
      ],
      [
        -3098.0,
        -3921.993896484375,
        1066.5999755859375
      ],
      [
        -3098.0,
        -3915.010009765625,
        1086.5999755859375
      ],
      [
        -3088.0,
        -3908.0,
        1081.9093017578125
      ],
      [
        -3089.89404296875,
        -3908.0,
        1086.5999755859375
      ],
      [
        -3098.0,
        -3921.993896484375,
        1066.5999755859375
      ],
      [
        -3108.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      [
        -3287.116943359375,
        -3901.268798828125,
        1076.5999755859375
      ],
      [
        -3287.116943359375,
        -3901.268798828125,
        1086.5999755859375
      ],
      [
        -3194.2265625,
        -3998.22705078125,
        1086.5999755859375
      ],
      [
        -3194.2265625,
        -3998.226806640625,
        1086.5999755859375
      ],
      [
        -3431.343017578125,
        -4043.953125,
        1052.623779296875
      ],
      [
        -3431.343017578125,
        -4043.953125,
        1102.623779296875
      ],
      [
        -3438.244384765625,
        -4197.02392578125,
        1121.623779296875
      ],
      [
        -3434.6865234375,
        -4200.58203125,
        1096.7835693359375
      ],
      [
        -3434.6865234375,
        -4200.58203125,
        1102.6231689453125
      ],
      [
        -3428.32373046875,
        -4188.44482421875,
        1121.623779296875
      ],
      [
        -3424.76611328125,
        -4192.00244140625,
        1052.623779296875
      ],
      [
        -3424.765869140625,
        -4192.00244140625,
        1102.6240234375
      ],
      [
        -3411.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      [
        -3405.5859375,
        -4076.0,
        1071.5999755859375
      ],
      [
        -3405.5859375,
        -4076.0,
        1074.5997314453125
      ],
      [
        -3381.343017578125,
        -4100.24267578125,
        1071.5999755859375
      ],
      [
        -3381.343017578125,
        -4100.24267578125,
        1074.5997314453125
      ],
      [
        -3381.343017578125,
        -4106.60546875,
        1071.5999755859375
      ],
      [
        -3411.343017578125,
        -4076.0,
        1071.885498046875
      ],
      [
        -3405.5859375,
        -4076.0,
        1074.5997314453125
      ],
      [
        -3405.5859375,
        -4076.0,
        1076.5999755859375
      ],
      [
        -3381.343017578125,
        -4100.24267578125,
        1074.5997314453125
      ],
      [
        -3381.343017578125,
        -4100.24267578125,
        1076.5999755859375
      ],
      [
        -3381.343017578125,
        -4103.384765625,
        1073.1182861328125
      ],
      [
        -3411.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      [
        -3368.11572265625,
        -4128.00830078125,
        1076.5999755859375
      ],
      [
        -3368.11572265625,
        -4128.00830078125,
        1086.5999755859375
      ],
      [
        -3415.4033203125,
        -4201.365234375,
        1052.623779296875
      ],
      [
        -3433.690185546875,
        -4201.578125,
        1097.302490234375
      ],
      [
        -3344.1220703125,
        -4131.3486328125,
        1076.5999755859375
      ],
      [
        -3347.388427734375,
        -4134.17333984375,
        1076.5999755859375
      ],
      [
        -3380.645263671875,
        -4162.93359375,
        1076.5999755859375
      ],
      [
        -3383.989013671875,
        -4165.82568359375,
        1076.5999755859375
      ],
      [
        -3347.388427734375,
        -4134.17333984375,
        1076.5999755859375
      ],
      [
        -3380.645263671875,
        -4162.93359375,
        1076.5999755859375
      ],
      [
        -3339.53857421875,
        -4135.7568359375,
        1052.623779296875
      ],
      [
        -3342.22705078125,
        -4136.0224609375,
        1058.5216064453125
      ],
      [
        -3375.86328125,
        -4164.03662109375,
        1061.5999755859375
      ],
      [
        -3377.923095703125,
        -4161.9765625,
        1072.5999755859375
      ],
      [
        -3348.673828125,
        -4136.681640625,
        1072.5999755859375
      ],
      [
        -3342.22705078125,
        -4136.0224609375,
        1058.5216064453125
      ],
      [
        -3354.945068359375,
        -4144.5498046875,
        1065.5999755859375
      ],
      [
        -3366.23828125,
        -4154.31591796875,
        1065.5999755859375
      ],
      [
        -3347.26416015625,
        -4142.4384765625,
        1052.623779296875
      ],
      [
        -3348.81494140625,
        -4140.64501953125,
        1061.5999755859375
      ],
      [
        -3348.81494140625,
        -4140.64501953125,
        1061.5999755859375
      ],
      [
        -3354.945068359375,
        -4144.5498046875,
        1065.5999755859375
      ],
      [
        -3366.23828125,
        -4154.31591796875,
        1065.5999755859375
      ],
      [
        -3371.518310546875,
        -4160.27880859375,
        1061.5999755859375
      ],
      [
        -3375.86328125,
        -4164.03662109375,
        1061.5999755859375
      ],
      [
        -3371.518310546875,
        -4160.27880859375,
        1061.5999755859375
      ],
      [
        -3380.0,
        -4159.89990234375,
        1058.4749755859375
      ],
      [
        -3348.674072265625,
        -4136.681640625,
        1072.5999755859375
      ],
      [
        -3348.65087890625,
        -4136.65673828125,
        1072.6136474609375
      ],
      [
        -3403.20263671875,
        -4187.33056640625,
        1062.5999755859375
      ],
      [
        -3401.47412109375,
        -4189.31884765625,
        1052.623779296875
      ],
      [
        -3409.0380859375,
        -4195.8603515625,
        1052.623779296875
      ],
      [
        -3410.766845703125,
        -4193.87158203125,
        1062.5999755859375
      ],
      [
        -3404.935791015625,
        -4185.3369140625,
        1072.5999755859375
      ],
      [
        -3403.20263671875,
        -4187.33056640625,
        1062.5999755859375
      ],
      [
        -3410.766845703125,
        -4193.87158203125,
        1062.5999755859375
      ],
      [
        -3412.49951171875,
        -4191.8779296875,
        1072.5999755859375
      ],
      [
        -3412.49951171875,
        -4191.8779296875,
        1072.5999755859375
      ],
      [
        -3404.935791015625,
        -4185.3369140625,
        1072.5999755859375
      ],
      [
        -3377.933349609375,
        -4161.98583984375,
        1072.5999755859375
      ],
      [
        -3386.263916015625,
        -4167.79296875,
        1076.5999755859375
      ],
      [
        -3342.398193359375,
        -4129.96923828125,
        1076.2808837890625
      ],
      [
        -3341.851806640625,
        -4129.38525390625,
        1076.5999755859375
      ],
      [
        -3342.398193359375,
        -4129.96923828125,
        1076.2808837890625
      ],
      [
        -3344.110595703125,
        -4129.94189453125,
        1080.5999755859375
      ],
      [
        -3343.96337890625,
        -4129.9052734375,
        1080.3402099609375
      ],
      [
        -3343.96337890625,
        -4129.9052734375,
        1080.3402099609375
      ],
      [
        -3341.851806640625,
        -4129.38525390625,
        1076.5999755859375
      ],
      [
        -3386.263916015625,
        -4167.79296875,
        1076.5999755859375
      ],
      [
        -3385.494873046875,
        -4165.73095703125,
        1080.5999755859375
      ],
      [
        -3384.736572265625,
        -4165.0751953125,
        1080.5999755859375
      ],
      [
        -3383.989013671875,
        -4165.82568359375,
        1076.5999755859375
      ],
      [
        -3384.736572265625,
        -4165.0751953125,
        1080.5999755859375
      ],
      [
        -3385.494873046875,
        -4165.73095703125,
        1080.5999755859375
      ],
      [
        -3344.121826171875,
        -4131.3486328125,
        1076.5999755859375
      ],
      [
        -3344.8671875,
        -4130.59619140625,
        1080.5999755859375
      ],
      [
        -3344.8671875,
        -4130.59619140625,
        1080.5999755859375
      ],
      [
        -3344.110595703125,
        -4129.94189453125,
        1080.5999755859375
      ],
      [
        -3411.724853515625,
        -4029.412109375,
        1070.813232421875
      ],
      [
        -3411.462646484375,
        -4029.67431640625,
        1071.5
      ],
      [
        -3411.724853515625,
        -4029.412109375,
        1070.813232421875
      ],
      [
        -3407.212646484375,
        -4024.89990234375,
        1052.623779296875
      ],
      [
        -3400.23046875,
        -4032.059814453125,
        1071.5
      ],
      [
        -3397.582763671875,
        -4029.412109375,
        1060.8275146484375
      ],
      [
        -3400.23046875,
        -4032.059814453125,
        1071.5
      ],
      [
        -3411.462646484375,
        -4029.67431640625,
        1071.5
      ],
      [
        -3400.71533203125,
        -4026.279541015625,
        1052.623779296875
      ],
      [
        -3397.582763671875,
        -4029.412109375,
        1060.8275146484375
      ],
      [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      [
        -3163.27734375,
        -3965.86669921875,
        1102.623779296875
      ],
      [
        -3098.0,
        -3937.650390625,
        1080.623779296875
      ],
      [
        -3098.0,
        -3937.650390625,
        1066.5999755859375
      ],
      [
        -3126.571044921875,
        -3950.0,
        1088.0
      ],
      [
        -3126.571044921875,
        -3950.0,
        1086.0
      ],
      [
        -3126.570556640625,
        -3950.0,
        1102.623779296875
      ],
      [
        -3126.57080078125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3119.63037109375,
        -3947.0,
        1071.0372314453125
      ],
      [
        -3119.630615234375,
        -3947.0,
        1085.0479736328125
      ],
      [
        -3119.630615234375,
        -3947.0,
        1085.0478515625
      ],
      [
        -3108.0,
        -3941.97265625,
        1080.623779296875
      ],
      [
        -3120.0,
        -3934.528564453125,
        1085.1883544921875
      ],
      [
        -3120.0,
        -3935.350830078125,
        1085.1883544921875
      ],
      [
        -3120.0,
        -3935.350830078125,
        1085.1883544921875
      ],
      [
        -3120.924560546875,
        -3935.205322265625,
        1085.5400390625
      ],
      [
        -3108.0,
        -3941.97265625,
        1066.5999755859375
      ],
      [
        -3119.63037109375,
        -3947.0,
        1071.0372314453125
      ],
      [
        -3098.0,
        -3937.650146484375,
        1066.5999755859375
      ],
      [
        -3108.0,
        -3941.97265625,
        1066.5999755859375
      ],
      [
        -3108.0,
        -3941.97265625,
        1080.623779296875
      ],
      [
        -3098.0,
        -3937.650390625,
        1080.623779296875
      ],
      [
        -3126.57080078125,
        -3950.0,
        1082.623779296875
      ],
      [
        -3147.131591796875,
        -3958.887451171875,
        1082.623779296875
      ],
      [
        -3140.0,
        -3955.804931640625,
        1096.5999755859375
      ],
      [
        -3140.0,
        -3955.804931640625,
        1082.623779296875
      ],
      [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      [
        -3140.0,
        -3955.804931640625,
        1096.5999755859375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1085.8109130859375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3051.571044921875,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -3208.600830078125,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3208.600830078125,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3181.398681640625,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3208.600830078125,
        -4239.7685546875,
        1087.26513671875
      ],
      [
        -3208.600830078125,
        -4249.7685546875,
        1087.26513671875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3182.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3182.499755859375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3207.499755859375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3169.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3182.499755859375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3182.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1063.970458984375
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1063.970458984375
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      [
        -3207.499755859375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1063.9708251953125
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1063.9708251953125
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3169.999755859375,
        -4239.7685546875,
        1067.623779296875
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      [
        -3169.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3169.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4239.7685546875,
        1052.623779296875
      ],
      [
        -3167.36328125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3395.499755859375,
        -4239.7685546875,
        1121.623779296875
      ],
      [
        -3395.499755859375,
        -4239.7685546875,
        1117.196044921875
      ],
      [
        -3086.468505859375,
        -4060.0,
        1082.623779296875
      ],
      [
        -3086.468505859375,
        -4060.0,
        1086.5999755859375
      ],
      [
        -3086.468505859375,
        -4060.0,
        1052.623779296875
      ],
      [
        -3086.468505859375,
        -4060.0,
        1082.623779296875
      ],
      [
        -3113.2578125,
        -3947.0,
        1082.623779296875
      ],
      [
        -3119.630615234375,
        -3947.0,
        1082.623779296875
      ],
      [
        -3113.2578125,
        -3947.0,
        1082.623779296875
      ],
      [
        -3113.2578125,
        -3944.245361328125,
        1082.623779296875
      ],
      [
        -3284.76171875,
        -4191.25048828125,
        1080.5999755859375
      ],
      [
        -3330.56494140625,
        -4145.029296875,
        1075.4033203125
      ],
      [
        -3343.898681640625,
        -4131.57421875,
        1075.40087890625
      ],
      [
        -3285.761962890625,
        -4190.2412109375,
        1075.39990234375
      ],
      [
        -3330.56494140625,
        -4145.029296875,
        1075.4033203125
      ],
      [
        -3282.76171875,
        -4193.26904296875,
        1076.5999755859375
      ],
      [
        -3284.76171875,
        -4191.25048828125,
        1080.5999755859375
      ],
      [
        -3282.76171875,
        -4193.26904296875,
        1076.5999755859375
      ],
      [
        -3285.761962890625,
        -4190.2412109375,
        1075.39990234375
      ],
      [
        -3337.58447265625,
        -4137.9462890625,
        1053.0928955078125
      ],
      [
        -3339.73388671875,
        -4135.7763671875,
        1053.0523681640625
      ],
      [
        -3337.302001953125,
        -4138.23095703125,
        1053.092529296875
      ],
      [
        -3337.58447265625,
        -4137.9462890625,
        1053.0928955078125
      ],
      [
        -3330.262939453125,
        -4145.333984375,
        1053.2139892578125
      ],
      [
        -3288.6005859375,
        -4187.37646484375,
        1053.959228515625
      ],
      [
        -3288.6005859375,
        -4187.37646484375,
        1053.959228515625
      ],
      [
        -3285.76171875,
        -4190.2412109375,
        1053.95556640625
      ],
      [
        -3285.26171875,
        -4190.74609375,
        1052.623779296875
      ],
      [
        -3285.76171875,
        -4190.2412109375,
        1053.95556640625
      ],
      [
        -3330.262451171875,
        -4145.33447265625,
        1052.623779296875
      ],
      [
        -3330.262939453125,
        -4145.333984375,
        1053.1907958984375
      ],
      [
        -3337.302001953125,
        -4138.23095703125,
        1053.071044921875
      ],
      [
        -3337.302490234375,
        -4138.23095703125,
        1052.623779296875
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1062.6473388671875
      ],
      [
        -3222.63623046875,
        -4232.6650390625,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4235.3251953125,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1058.8939208984375
      ],
      [
        -3421.020751953125,
        -4195.74755859375,
        1082.623779296875
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3326.5751953125,
        -4161.92724609375,
        1076.5999755859375
      ],
      [
        -3326.019775390625,
        -4161.69677734375,
        1076.5999755859375
      ],
      [
        -3323.982666015625,
        -4163.75341796875,
        1076.5999755859375
      ],
      [
        -3324.39404296875,
        -4164.109375,
        1076.5999755859375
      ],
      [
        -3326.02001953125,
        -4161.69677734375,
        1076.5999755859375
      ],
      [
        -3326.575439453125,
        -4161.92724609375,
        1076.5999755859375
      ],
      [
        -3345.59912109375,
        -4142.8994140625,
        1076.5999755859375
      ],
      [
        -3345.850830078125,
        -4141.671875,
        1076.5999755859375
      ],
      [
        -3294.27978515625,
        -4193.7470703125,
        1076.5999755859375
      ],
      [
        -3294.621826171875,
        -4193.8876953125,
        1076.5999755859375
      ],
      [
        -3324.39404296875,
        -4164.10888671875,
        1076.5999755859375
      ],
      [
        -3323.98291015625,
        -4163.75341796875,
        1076.5999755859375
      ],
      [
        -3285.76171875,
        -4202.3486328125,
        1076.5999755859375
      ],
      [
        -3285.76171875,
        -4202.7490234375,
        1076.5999755859375
      ],
      [
        -3294.621826171875,
        -4193.8876953125,
        1076.5999755859375
      ],
      [
        -3294.27978515625,
        -4193.7470703125,
        1076.5999755859375
      ],
      [
        -3345.850830078125,
        -4141.671875,
        1076.5999755859375
      ],
      [
        -3345.59912109375,
        -4142.8994140625,
        1076.5999755859375
      ],
      [
        -3351.107421875,
        -4137.3896484375,
        1076.5999755859375
      ],
      [
        -3350.587890625,
        -4136.9404296875,
        1076.5999755859375
      ],
      [
        -3285.26171875,
        -4203.25,
        1052.623779296875
      ],
      [
        -3292.76171875,
        -4195.74853515625,
        1072.5999755859375
      ],
      [
        -3339.879638671875,
        -4144.32568359375,
        1070.0885009765625
      ],
      [
        -3341.637939453125,
        -4142.5673828125,
        1070.0885009765625
      ],
      [
        -3339.879638671875,
        -4144.32568359375,
        1070.0885009765625
      ],
      [
        -3282.76171875,
        -4205.75,
        1076.5999755859375
      ],
      [
        -3282.76171875,
        -4205.3779296875,
        1076.5999755859375
      ],
      [
        -3292.76171875,
        -4195.74853515625,
        1072.5999755859375
      ],
      [
        -3282.76171875,
        -4205.3779296875,
        1076.5999755859375
      ],
      [
        -3282.76171875,
        -4205.75,
        1076.5999755859375
      ],
      [
        -3283.11328125,
        -4205.39892578125,
        1077.302978515625
      ],
      [
        -3285.76171875,
        -4202.7490234375,
        1076.5999755859375
      ],
      [
        -3285.76171875,
        -4202.3486328125,
        1076.5999755859375
      ],
      [
        -3285.76171875,
        -4202.7490234375,
        1077.349365234375
      ],
      [
        -3338.300048828125,
        -4201.7548828125,
        1067.5
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1067.5
      ],
      [
        -3290.846923828125,
        -4239.7685546875,
        1067.5
      ],
      [
        -3290.846923828125,
        -4197.66357421875,
        1067.5
      ],
      [
        -3337.0,
        -4235.0,
        1067.5
      ],
      [
        -3347.0,
        -4235.0,
        1067.5
      ],
      [
        -3337.0,
        -4225.0,
        1067.5
      ],
      [
        -3337.0,
        -4235.0,
        1067.5
      ],
      [
        -3347.0,
        -4225.0,
        1067.5
      ],
      [
        -3337.0,
        -4225.0,
        1067.5
      ],
      [
        -3347.0,
        -4235.0,
        1067.5
      ],
      [
        -3347.0,
        -4225.0,
        1067.5
      ],
      [
        -3372.89990234375,
        -4167.0,
        1072.5894775390625
      ],
      [
        -3372.890625,
        -4167.00927734375,
        1072.5894775390625
      ],
      [
        -3372.890625,
        -4167.00927734375,
        1072.5894775390625
      ],
      [
        -3359.782470703125,
        -4167.98828125,
        1069.1522216796875
      ],
      [
        -3356.84033203125,
        -4165.08935546875,
        1067.5
      ],
      [
        -3345.884033203125,
        -4176.0830078125,
        1067.5
      ],
      [
        -3349.3388671875,
        -4179.07080078125,
        1069.322509765625
      ],
      [
        -3359.782470703125,
        -4167.98828125,
        1069.1522216796875
      ],
      [
        -3349.3388671875,
        -4179.07080078125,
        1069.322509765625
      ],
      [
        -3377.922119140625,
        -4161.9775390625,
        1072.594482421875
      ],
      [
        -3372.89990234375,
        -4167.0,
        1072.5894775390625
      ],
      [
        -3342.67236328125,
        -4197.36328125,
        1067.5
      ],
      [
        -3338.300048828125,
        -4201.7548828125,
        1067.5
      ],
      [
        -3372.89990234375,
        -4167.0,
        1067.5
      ],
      [
        -3368.387939453125,
        -4171.5322265625,
        1067.5
      ],
      [
        -3368.387939453125,
        -4171.5322265625,
        1067.5
      ],
      [
        -3342.67236328125,
        -4197.36328125,
        1067.5
      ],
      [
        -3397.490234375,
        -4193.90234375,
        1067.5
      ],
      [
        -3404.052001953125,
        -4186.353515625,
        1067.5
      ],
      [
        -3411.615966796875,
        -4192.89453125,
        1067.5
      ],
      [
        -3405.037109375,
        -4200.46240234375,
        1067.5
      ],
      [
        -3405.037109375,
        -4200.46240234375,
        1067.5
      ],
      [
        -3397.490234375,
        -4193.90234375,
        1067.5
      ],
      [
        -3376.968017578125,
        -4162.931640625,
        1067.5
      ],
      [
        -3372.89990234375,
        -4167.0,
        1067.5
      ],
      [
        -3336.0,
        -4213.97900390625,
        1076.5999755859375
      ],
      [
        -3336.0,
        -4218.2294921875,
        1076.5999755859375
      ],
      [
        -3336.0,
        -4215.39599609375,
        1080.5999755859375
      ],
      [
        -3336.0,
        -4213.97900390625,
        1080.5999755859375
      ],
      [
        -3343.333251953125,
        -4210.8701171875,
        1076.5999755859375
      ],
      [
        -3341.189697265625,
        -4208.77197265625,
        1076.5999755859375
      ],
      [
        -3340.276611328125,
        -4209.6884765625,
        1080.5999755859375
      ],
      [
        -3340.990478515625,
        -4210.38720703125,
        1080.5999755859375
      ],
      [
        -3350.37255859375,
        -4203.80712890625,
        1076.5999755859375
      ],
      [
        -3348.9462890625,
        -4202.40478515625,
        1080.5999755859375
      ],
      [
        -3371.0078125,
        -4239.7685546875,
        1080.5999755859375
      ],
      [
        -3337.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3336.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3347.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3337.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3336.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3337.0,
        -4235.0,
        1080.5999755859375
      ],
      [
        -3347.0,
        -4235.0,
        1080.5999755859375
      ],
      [
        -3336.0,
        -4235.0,
        1080.5999755859375
      ],
      [
        -3336.0,
        -4239.7685546875,
        1080.5999755859375
      ],
      [
        -3347.0,
        -4235.0,
        1080.5999755859375
      ],
      [
        -3347.0,
        -4225.0,
        1080.5999755859375
      ],
      [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3340.233642578125,
        -4209.7314453125,
        1080.7877197265625
      ],
      [
        -3342.94775390625,
        -4213.21923828125,
        1082.623779296875
      ],
      [
        -3336.0,
        -4235.0,
        1082.623779296875
      ],
      [
        -3336.0,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3336.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3336.0,
        -4213.97900390625,
        1082.623779296875
      ],
      [
        -3337.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3336.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3347.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3337.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3337.0,
        -4235.0,
        1082.623779296875
      ],
      [
        -3347.0,
        -4235.0,
        1082.623779296875
      ],
      [
        -3347.0,
        -4235.0,
        1082.623779296875
      ],
      [
        -3347.0,
        -4225.0,
        1082.623779296875
      ],
      [
        -3339.900634765625,
        -4210.0654296875,
        1082.623779296875
      ],
      [
        -3342.94775390625,
        -4213.21923828125,
        1082.623779296875
      ],
      [
        -3340.233642578125,
        -4209.7314453125,
        1080.7877197265625
      ],
      [
        -3297.279052734375,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3297.279052734375,
        -4194.9736328125,
        1082.623779296875
      ],
      [
        -3300.800048828125,
        -4196.40087890625,
        1082.623779296875
      ],
      [
        -3300.800048828125,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3297.279052734375,
        -4194.9736328125,
        1082.623779296875
      ],
      [
        -3300.800048828125,
        -4191.3876953125,
        1082.623779296875
      ],
      [
        -3300.800048828125,
        -4190.45166015625,
        1080.014404296875
      ],
      [
        -3300.800048828125,
        -4189.23388671875,
        1076.5999755859375
      ],
      [
        -3300.800048828125,
        -4190.45166015625,
        1080.014404296875
      ],
      [
        -3304.650390625,
        -4187.466796875,
        1082.623779296875
      ],
      [
        -3325.080810546875,
        -4166.69384765625,
        1082.623779296875
      ],
      [
        -3304.650390625,
        -4187.466796875,
        1082.623779296875
      ],
      [
        -3325.080810546875,
        -4166.69384765625,
        1082.623779296875
      ],
      [
        -3347.4892578125,
        -4186.07275390625,
        1082.623779296875
      ],
      [
        -3324.30224609375,
        -4172.5888671875,
        1082.623779296875
      ],
      [
        -3307.878662109375,
        -4189.22802734375,
        1082.623779296875
      ],
      [
        -3300.800048828125,
        -4196.40087890625,
        1082.623779296875
      ],
      [
        -3307.878662109375,
        -4189.22802734375,
        1082.623779296875
      ],
      [
        -3336.0,
        -4212.0,
        1082.623779296875
      ],
      [
        -3321.5,
        -4201.5,
        1082.623779296875
      ],
      [
        -3338.30224609375,
        -4184.7890625,
        1082.623779296875
      ],
      [
        -3324.30224609375,
        -4172.5888671875,
        1082.623779296875
      ],
      [
        -3347.4892578125,
        -4186.07275390625,
        1082.623779296875
      ],
      [
        -3343.9140625,
        -4189.6796875,
        1082.623779296875
      ],
      [
        -3345.052001953125,
        -4190.6708984375,
        1076.5999755859375
      ],
      [
        -3321.5,
        -4201.5,
        1082.623779296875
      ],
      [
        -3328.035400390625,
        -4195.0,
        1082.623779296875
      ],
      [
        -3331.906982421875,
        -4201.79248046875,
        1082.623779296875
      ],
      [
        -3333.346435546875,
        -4200.34033203125,
        1082.623779296875
      ],
      [
        -3328.035400390625,
        -4195.0,
        1082.623779296875
      ],
      [
        -3331.906982421875,
        -4201.79248046875,
        1082.623779296875
      ],
      [
        -3333.346435546875,
        -4200.34033203125,
        1082.623779296875
      ],
      [
        -3338.30224609375,
        -4184.7890625,
        1082.623779296875
      ],
      [
        -3343.540771484375,
        -4190.05615234375,
        1082.623779296875
      ],
      [
        -3343.540771484375,
        -4190.05615234375,
        1082.623779296875
      ],
      [
        -3336.0,
        -4212.0,
        1082.623779296875
      ],
      [
        -3285.76171875,
        -4204.48681640625,
        1080.5999755859375
      ],
      [
        -3284.76171875,
        -4205.49609375,
        1080.5999755859375
      ],
      [
        -3285.76171875,
        -4204.48681640625,
        1080.5999755859375
      ],
      [
        -3284.76171875,
        -4205.49609375,
        1080.5999755859375
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1067.0433349609375
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1053.2899169921875
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1067.0433349609375
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1067.5
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1053.2899169921875
      ],
      [
        -3337.251708984375,
        -4200.72509765625,
        1052.623779296875
      ],
      [
        -3313.757568359375,
        -4222.0,
        1052.623779296875
      ],
      [
        -3313.757568359375,
        -4222.0,
        1056.0
      ],
      [
        -3313.757568359375,
        -4222.0,
        1064.0999755859375
      ],
      [
        -3313.757568359375,
        -4222.0,
        1067.5
      ],
      [
        -3372.910888671875,
        -4166.9892578125,
        1061.5999755859375
      ],
      [
        -3375.85595703125,
        -4164.0302734375,
        1061.5999755859375
      ],
      [
        -3376.050537109375,
        -4163.84912109375,
        1062.5999755859375
      ],
      [
        -3372.89990234375,
        -4167.0,
        1062.5999755859375
      ],
      [
        -3350.560302734375,
        -4136.91650390625,
        1076.5999755859375
      ],
      [
        -3285.73291015625,
        -4190.2705078125,
        1075.4114990234375
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1062.68994140625
      ],
      [
        -3222.63623046875,
        -4232.6044921875,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4235.2646484375,
        1052.623779296875
      ],
      [
        -3219.999755859375,
        -4239.7685546875,
        1058.951904296875
      ],
      [
        -3234.283935546875,
        -4089.69140625,
        1052.623779296875
      ],
      [
        -3234.283935546875,
        -4089.69140625,
        1072.5887451171875
      ],
      [
        -3186.496337890625,
        -4042.05517578125,
        1052.623779296875
      ],
      [
        -3177.596435546875,
        -4050.955078125,
        1052.623779296875
      ],
      [
        -3186.496337890625,
        -4042.05517578125,
        1072.2554931640625
      ],
      [
        -3186.496337890625,
        -4042.05517578125,
        1072.623779296875
      ],
      [
        -3234.283935546875,
        -4089.69140625,
        1072.623779296875
      ],
      [
        -3169.999755859375,
        -4179.7685546875,
        1071.313232421875
      ],
      [
        -3169.999755859375,
        -4239.7685546875,
        1071.313232421875
      ],
      [
        -3169.999755859375,
        -4179.7685546875,
        1071.313232421875
      ],
      [
        -3173.608154296875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3173.608154296875,
        -4239.7685546875,
        1072.623779296875
      ],
      [
        -3170.936279296875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3170.936279296875,
        -4239.7685546875,
        1072.623779296875
      ],
      [
        -3173.608154296875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3170.936279296875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3219.063232421875,
        -4239.7685546875,
        1072.623779296875
      ],
      [
        -3219.063232421875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3216.391357421875,
        -4239.7685546875,
        1072.623779296875
      ],
      [
        -3222.63623046875,
        -4239.7685546875,
        1063.970703125
      ],
      [
        -3222.63623046875,
        -4179.7685546875,
        1063.9708251953125
      ],
      [
        -3222.63623046875,
        -4179.7685546875,
        1063.9708251953125
      ],
      [
        -3216.391357421875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3219.063232421875,
        -4179.7685546875,
        1072.623779296875
      ],
      [
        -3180.824951171875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3180.824951171875,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3178.08203125,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3178.08203125,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3180.824951171875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3178.08203125,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3209.174560546875,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3211.91748046875,
        -4239.7685546875,
        1082.623779296875
      ],
      [
        -3211.91748046875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3211.91748046875,
        -4179.7685546875,
        1082.623779296875
      ],
      [
        -3128.210693359375,
        -4060.0,
        1082.623779296875
      ],
      [
        -3128.210693359375,
        -4060.0,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3942.823486328125,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3970.0,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3172.531982421875,
        -3979.46533203125,
        1086.5999755859375
      ],
      [
        -3169.5,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3130.999267578125,
        -4018.5,
        1086.5999755859375
      ],
      [
        -3130.999267578125,
        -4018.5,
        1082.623779296875
      ],
      [
        -3112.968505859375,
        -3997.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -4000.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3970.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3950.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -4016.0,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1082.623779296875
      ],
      [
        -3112.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3970.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3970.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -4016.0,
        1086.5999755859375
      ],
      [
        -3125.0,
        -3950.0,
        1086.5999755859375
      ],
      [
        -3126.571044921875,
        -3950.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3950.0,
        1086.5999755859375
      ],
      [
        -3126.57080078125,
        -3950.0,
        1086.5999755859375
      ],
      [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      [
        -3126.5,
        -3990.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -3990.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -4002.5,
        1086.5999755859375
      ],
      [
        -3126.5,
        -3990.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -4002.5,
        1086.5999755859375
      ],
      [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3990.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -3990.0,
        1086.5999755859375
      ],
      [
        -3121.5,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3975.0,
        1086.5999755859375
      ],
      [
        -3150.0,
        -3975.0,
        1086.5999755859375
      ],
      [
        -3150.0,
        -3975.0,
        1086.5999755859375
      ],
      [
        -3150.0,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3975.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3150.0,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3985.0,
        1086.5999755859375
      ],
      [
        -3169.5,
        -3980.0,
        1086.5999755859375
      ],
      [
        -3169.5,
        -3976.84326171875,
        1086.5999755859375
      ],
      [
        -3144.0,
        -3960.0,
        1082.623779296875
      ],
      [
        -3146.0,
        -3960.0,
        1082.623779296875
      ],
      [
        -3146.0,
        -3960.0,
        1086.0
      ],
      [
        -3144.0,
        -3960.0,
        1086.0
      ],
      [
        -3146.0,
        -3960.0,
        1086.5999755859375
      ],
      [
        -3144.0,
        -3960.0,
        1086.5999755859375
      ],
      [
        -3149.70458984375,
        -3960.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3960.0,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3955.804931640625,
        1086.5999755859375
      ],
      [
        -3140.0,
        -3960.0,
        1086.5999755859375
      ],
      [
        -3421.765380859375,
        -4195.0029296875,
        1086.5999755859375
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3209.076171875,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3209.076171875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3180.92333984375,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3179.740234375,
        -4179.7685546875,
        1084.9443359375
      ],
      [
        -3179.740234375,
        -4239.7685546875,
        1084.9443359375
      ],
      [
        -3180.92333984375,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3208.28515625,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3209.076171875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3210.25927734375,
        -4179.7685546875,
        1084.9443359375
      ],
      [
        -3181.71435546875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3179.740234375,
        -4179.7685546875,
        1084.9443359375
      ],
      [
        -3180.92333984375,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3208.28515625,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3181.71435546875,
        -4179.7685546875,
        1086.5999755859375
      ],
      [
        -3298.28076171875,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3298.28076171875,
        -4195.38037109375,
        1086.5999755859375
      ],
      [
        -3300.800048828125,
        -4196.40185546875,
        1086.5999755859375
      ],
      [
        -3300.800048828125,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3298.28076171875,
        -4195.38037109375,
        1086.5999755859375
      ],
      [
        -3300.800048828125,
        -4192.81494140625,
        1086.5999755859375
      ],
      [
        -3300.800048828125,
        -4191.3876953125,
        1082.623779296875
      ],
      [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      [
        -3348.82568359375,
        -4220.7724609375,
        1086.5999755859375
      ],
      [
        -3336.0,
        -4212.0,
        1086.5999755859375
      ],
      [
        -3321.5,
        -4201.5,
        1086.5999755859375
      ],
      [
        -3304.418212890625,
        -4189.13037109375,
        1086.5999755859375
      ],
      [
        -3310.33837890625,
        -4183.1015625,
        1086.5999755859375
      ],
      [
        -3310.343994140625,
        -4183.0537109375,
        1086.482177734375
      ],
      [
        -3303.59912109375,
        -4188.53759765625,
        1082.623779296875
      ],
      [
        -3310.529541015625,
        -4181.48876953125,
        1082.623779296875
      ],
      [
        -3310.343994140625,
        -4183.0537109375,
        1086.482177734375
      ],
      [
        -3312.225830078125,
        -4184.82373046875,
        1086.3231201171875
      ],
      [
        -3313.066650390625,
        -4183.97216796875,
        1082.623779296875
      ],
      [
        -3306.49267578125,
        -4190.6328125,
        1082.623779296875
      ],
      [
        -3312.225830078125,
        -4184.82373046875,
        1086.3231201171875
      ],
      [
        -3312.1630859375,
        -4184.8876953125,
        1086.5999755859375
      ],
      [
        -3306.4931640625,
        -4190.63330078125,
        1086.5999755859375
      ],
      [
        -3321.5,
        -4201.5,
        1086.5999755859375
      ],
      [
        -3325.287109375,
        -4197.7333984375,
        1086.5999755859375
      ],
      [
        -3326.19921875,
        -4196.826171875,
        1082.623779296875
      ],
      [
        -3336.0,
        -4212.0,
        1086.5999755859375
      ],
      [
        -3300.800048828125,
        -4196.40185546875,
        1086.5999755859375
      ],
      [
        -3325.1357421875,
        -4168.0556640625,
        1086.5999755859375
      ],
      [
        -3346.0341796875,
        -4186.12890625,
        1086.5999755859375
      ],
      [
        -3310.517822265625,
        -4182.9189453125,
        1086.5999755859375
      ],
      [
        -3325.1357421875,
        -4168.0556640625,
        1086.5999755859375
      ],
      [
        -3310.517822265625,
        -4182.9189453125,
        1086.5999755859375
      ],
      [
        -3330.4970703125,
        -4201.802734375,
        1086.5999755859375
      ],
      [
        -3348.82568359375,
        -4220.7724609375,
        1086.5999755859375
      ],
      [
        -3313.168701171875,
        -4183.86865234375,
        1086.5999755859375
      ],
      [
        -3312.55126953125,
        -4184.494140625,
        1086.5999755859375
      ],
      [
        -3313.88623046875,
        -4183.1416015625,
        1082.623779296875
      ],
      [
        -3312.55126953125,
        -4184.494140625,
        1086.5999755859375
      ],
      [
        -3325.938720703125,
        -4197.0849609375,
        1086.5999755859375
      ],
      [
        -3326.662841796875,
        -4196.365234375,
        1082.623779296875
      ],
      [
        -3338.30224609375,
        -4184.7890625,
        1086.5999755859375
      ],
      [
        -3324.30224609375,
        -4172.5888671875,
        1086.5999755859375
      ],
      [
        -3346.0341796875,
        -4186.12890625,
        1086.5999755859375
      ],
      [
        -3343.163330078125,
        -4189.02490234375,
        1086.5999755859375
      ],
      [
        -3343.9140625,
        -4189.6796875,
        1082.623779296875
      ],
      [
        -3324.30224609375,
        -4172.5888671875,
        1086.5999755859375
      ],
      [
        -3332.6455078125,
        -4199.6357421875,
        1086.5999755859375
      ],
      [
        -3328.035400390625,
        -4195.0,
        1086.5999755859375
      ],
      [
        -3330.4970703125,
        -4201.802734375,
        1086.5999755859375
      ],
      [
        -3332.6455078125,
        -4199.6357421875,
        1086.5999755859375
      ],
      [
        -3328.035400390625,
        -4195.0,
        1086.5999755859375
      ],
      [
        -3338.30224609375,
        -4184.7890625,
        1086.5999755859375
      ],
      [
        -3342.83984375,
        -4189.3515625,
        1086.5999755859375
      ],
      [
        -3342.83984375,
        -4189.3515625,
        1086.5999755859375
      ],
      [
        -3424.765869140625,
        -4192.00244140625,
        1102.623779296875
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1102.623779296875
      ],
      [
        -3434.6865234375,
        -4200.58154296875,
        1102.623779296875
      ],
      [
        -3423.474609375,
        -4211.79345703125,
        1102.623779296875
      ],
      [
        -3300.800048828125,
        -4192.81494140625,
        1086.5999755859375
      ],
      [
        -3313.08642578125,
        -4183.95166015625,
        1087.0555419921875
      ],
      [
        -3313.168701171875,
        -4183.86865234375,
        1086.5999755859375
      ],
      [
        -3311.365234375,
        -4185.6982421875,
        1096.5999755859375
      ],
      [
        -3313.08642578125,
        -4183.95166015625,
        1087.0555419921875
      ],
      [
        -3311.339111328125,
        -4185.6708984375,
        1096.5999755859375
      ],
      [
        -3311.388427734375,
        -4182.244140625,
        1087.18994140625
      ],
      [
        -3311.39208984375,
        -4182.02978515625,
        1086.5999755859375
      ],
      [
        -3311.388427734375,
        -4182.244140625,
        1087.18994140625
      ],
      [
        -3324.11767578125,
        -4198.896484375,
        1096.5999755859375
      ],
      [
        -3325.938720703125,
        -4197.0849609375,
        1086.5999755859375
      ],
      [
        -3341.27490234375,
        -4187.37939453125,
        1096.5999755859375
      ],
      [
        -3343.163330078125,
        -4189.02490234375,
        1086.5999755859375
      ],
      [
        -3109.968505859375,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -3970.0,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -3942.823486328125,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -3970.0,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3160.0,
        -3991.997314453125,
        1096.5999755859375
      ],
      [
        -3174.404541015625,
        -3977.5927734375,
        1096.5999755859375
      ],
      [
        -3160.0,
        -3991.997314453125,
        1096.5999755859375
      ],
      [
        -3133.49755859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3169.5,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3160.0,
        -3989.5,
        1096.5999755859375
      ],
      [
        -3133.5,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3160.0,
        -3989.5,
        1096.5999755859375
      ],
      [
        -3130.999267578125,
        -4018.5,
        1092.0
      ],
      [
        -3133.49755859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3130.999267578125,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3130.999267578125,
        -4018.5,
        1092.0
      ],
      [
        -3112.968505859375,
        -3970.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3970.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3950.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3117.0,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3117.0,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3133.5,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3117.0,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3117.0,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3950.0,
        1096.5999755859375
      ],
      [
        -3126.570556640625,
        -3950.0,
        1096.5999755859375
      ],
      [
        -3169.5,
        -3980.0,
        1096.5999755859375
      ],
      [
        -3169.5,
        -3973.3515625,
        1096.5999755859375
      ],
      [
        -3311.339111328125,
        -4185.6708984375,
        1100.5999755859375
      ],
      [
        -3311.339111328125,
        -4185.6708984375,
        1096.5999755859375
      ],
      [
        -3109.968505859375,
        -3977.256591796875,
        1102.623779296875
      ],
      [
        -3109.968505859375,
        -3977.256591796875,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -3980.361572265625,
        1102.623779296875
      ],
      [
        -3112.968505859375,
        -3980.361572265625,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1096.5999755859375
      ],
      [
        -3112.968505859375,
        -4018.5,
        1102.623779296875
      ],
      [
        -3135.99755859375,
        -4016.0,
        1102.623779296875
      ],
      [
        -3135.99755859375,
        -4016.0,
        1096.5999755859375
      ],
      [
        -3140.57080078125,
        -4008.92919921875,
        1102.623779296875
      ],
      [
        -3140.57080078125,
        -4008.92919921875,
        1096.5999755859375
      ],
      [
        -3141.7978515625,
        -4010.199462890625,
        1102.623779296875
      ],
      [
        -3141.7978515625,
        -4010.199462890625,
        1096.5999755859375
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3699.999755859375,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3319.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3199.588623046875,
        -4741.14697265625,
        1052.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3231.590087890625,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3231.940185546875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3243.922119140625,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.9658203125,
        -4854.802734375,
        1202.759765625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1102.6241455078125
      ],
      [
        -3332.493896484375,
        -4850.7685546875,
        1152.5999755859375
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3302.37060546875,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3308.169189453125,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3223.03857421875,
        -4750.25830078125,
        1052.623779296875
      ],
      [
        -3223.016357421875,
        -4750.28173828125,
        1082.623779296875
      ],
      [
        -3270.07763671875,
        -4850.7685546875,
        1082.70166015625
      ],
      [
        -3252.545654296875,
        -4813.37158203125,
        1098.623779296875
      ],
      [
        -3270.034423828125,
        -4850.7138671875,
        1098.61474609375
      ],
      [
        -3270.034423828125,
        -4850.7138671875,
        1098.61474609375
      ],
      [
        -3270.06005859375,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3292.78662109375,
        -4850.7685546875,
        1098.123779296875
      ],
      [
        -3292.78662109375,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1082.623779296875
      ],
      [
        -3264.06005859375,
        -4787.7001953125,
        1095.0885009765625
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1094.9818115234375
      ],
      [
        -3264.06005859375,
        -4787.7001953125,
        1095.0885009765625
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1095.1317138671875
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1095.1212158203125
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1095.1317138671875
      ],
      [
        -3264.76904296875,
        -4787.7001953125,
        1095.1212158203125
      ],
      [
        -3292.78662109375,
        -4850.7685546875,
        1098.623779296875
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3302.565185546875,
        -4855.56982421875,
        1213.0048828125
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3699.999755859375,
        -4853.626953125,
        1198.05712890625
      ],
      [
        -3303.63720703125,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3600.0,
        -4863.9697265625,
        1239.427978515625
      ],
      [
        -3600.0,
        -4854.5673828125,
        1201.8182373046875
      ],
      [
        -3566.1171875,
        -4863.6513671875,
        1238.15380859375
      ],
      [
        -3600.0,
        -4879.7685546875,
        1302.623779296875
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3151.214111328125,
        -4409.7685546875,
        1056.623779296875
      ],
      [
        -3151.214111328125,
        -4389.7685546875,
        1056.623779296875
      ],
      [
        -2182.125244140625,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -2214.77978515625,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -2182.12548828125,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3749.999755859375,
        -4839.27294921875,
        1302.623779296875
      ],
      [
        -3963.99951171875,
        -4828.22119140625,
        1402.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1012.623779296875,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26261258125305176,
        0.2626130282878876,
        0.9284766912460327
      ],
      "plane_d": -766.841552734375,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1032.623779296875,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3889.142822265625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 559.6640625,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3889.142822265625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -3276.144775390625,
        -4099.5751953125,
        1032.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -3911.484375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071040868759155,
        -0.0
      ],
      "plane_d": 5192.830078125,
      "bbox_min": [
        -3276.144775390625,
        -4099.5751953125,
        1032.623779296875
      ],
      "bbox_max": [
        -3234.2998046875,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5178.83251953125,
      "bbox_min": [
        -3266.245361328125,
        -4089.675537109375,
        1032.623779296875
      ],
      "bbox_max": [
        -3234.2998046875,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": 530.6748657226562,
      "bbox_min": [
        -3129.628662109375,
        -3926.160400390625,
        1045.7926025390625
      ],
      "bbox_max": [
        -3120.0,
        -3911.484375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -3889.142822265625,
        1049.7808837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.0,
      "bbox_min": [
        -3120.0,
        -3911.484375,
        1040.0
      ],
      "bbox_max": [
        -3120.0,
        -3889.142822265625,
        1049.7808837890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3372.23583984375,
        -4133.39013671875,
        1032.623779296875
      ],
      "bbox_max": [
        -3341.90576171875,
        -4103.06005859375,
        1049.7808837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": -3977.16259765625,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": -2452.34423828125,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3942.054443359375,
        1012.623779296875
      ],
      "bbox_max": [
        -3250.399169921875,
        -3890.92822265625,
        1042.7222900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": 3224.4716796875,
      "bbox_min": [
        -3442.946533203125,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071054577827454,
        0.7071081399917603,
        0.0
      ],
      "plane_d": 559.674072265625,
      "bbox_min": [
        -3411.724853515625,
        -4133.39013671875,
        1012.623779296875
      ],
      "bbox_max": [
        -3200.484375,
        -3917.5,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071040868759155,
        -0.0
      ],
      "plane_d": 5192.830078125,
      "bbox_min": [
        -3276.144775390625,
        -4072.65478515625,
        1049.781005859375
      ],
      "bbox_max": [
        -3261.219970703125,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5178.83251953125,
      "bbox_min": [
        -3266.245361328125,
        -4062.75537109375,
        1049.781005859375
      ],
      "bbox_max": [
        -3261.219970703125,
        -4057.72998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3411.724853515625,
        -4036.483154296875,
        1012.623779296875
      ],
      "bbox_max": [
        -3200.484375,
        -3917.5,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5261.6787109375,
      "bbox_min": [
        -3411.724853515625,
        -4036.483154296875,
        1012.623779296875
      ],
      "bbox_max": [
        -3404.65380859375,
        -4022.341064453125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 436.770751953125,
      "bbox_min": [
        -3411.724853515625,
        -4029.412109375,
        1012.623779296875
      ],
      "bbox_max": [
        -3404.65380859375,
        -4022.341064453125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 5221.6787109375,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1012.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -446.770751953125,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1012.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5231.6787109375,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1012.623779296875
      ],
      "bbox_max": [
        -3383.440673828125,
        -4001.1279296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 436.770751953125,
      "bbox_min": [
        -3390.51171875,
        -4008.198974609375,
        1012.623779296875
      ],
      "bbox_max": [
        -3383.440673828125,
        -4001.1279296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.3826836347579956,
        0.9238794445991516
      ],
      "plane_d": 530.6748657226562,
      "bbox_min": [
        -3301.525146484375,
        -3926.160400390625,
        1031.7159423828125
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3294.953125,
        -3925.783935546875,
        1031.7159423828125
      ],
      "bbox_max": [
        -3266.66943359375,
        -3897.500244140625,
        1051.715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3926.160400390625,
        1040.0
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3120.0,
      "bbox_min": [
        -3240.0,
        -3926.160400390625,
        1040.0
      ],
      "bbox_max": [
        -3120.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3240.0,
      "bbox_min": [
        -3240.0,
        -3926.160400390625,
        1040.0
      ],
      "bbox_max": [
        -3240.0,
        -3868.839599609375,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -3155.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3020.999755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000001192092896,
        0.0
      ],
      "plane_d": -232.342041015625,
      "bbox_min": [
        -2739.973876953125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4020.00439453125,
        1226.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2369.712646484375,
        -4155.2939453125,
        1082.623779296875
      ],
      "bbox_max": [
        -2354.909423828125,
        -4138.85302734375,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2615.537109375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4065.557373046875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2341.7802734375,
        -4229.22412109375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2615.537109375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4065.557373046875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790370345115662,
        0.7341040372848511,
        0.0
      ],
      "plane_d": 1525.21728515625,
      "bbox_min": [
        -2354.91015625,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.29296875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2354.91015625,
        -4210.19482421875,
        1082.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4155.29296875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000026226043701,
        -0.8660238981246948,
        2.5891913537634537e-05
      ],
      "plane_d": -4828.673828125,
      "bbox_min": [
        -2615.537109375,
        -4072.557373046875,
        1112.623779296875
      ],
      "bbox_max": [
        -2603.412353515625,
        -4065.557373046875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2589.23681640625,
        -3984.21875,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071112990379333,
        0.7071022987365723,
        0.0
      ],
      "plane_d": 1071.87548828125,
      "bbox_min": [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.08251953125,
        -3990.27880859375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -2739.973876953125,
        -4244.7236328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.08251953125,
        -3990.27880859375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7492340207099915,
        0.4325691759586334,
        0.5015299916267395
      ],
      "plane_d": -780.37060546875,
      "bbox_min": [
        -2682.318603515625,
        -4076.552490234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2606.08251953125,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.753229558467865,
        0.42559191584587097,
        0.5015146136283875
      ],
      "plane_d": -818.7469482421875,
      "bbox_min": [
        -2653.26416015625,
        -4065.557373046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2615.536865234375,
        -3990.27880859375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000026226043701,
        -0.8660238981246948,
        2.5891913537634537e-05
      ],
      "plane_d": -4828.673828125,
      "bbox_min": [
        -2636.4775390625,
        -4065.557373046875,
        1112.623779296875
      ],
      "bbox_max": [
        -2615.536865234375,
        -4053.46728515625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7604051232337952,
        0.44977569580078125,
        0.46849310398101807
      ],
      "plane_d": -706.0,
      "bbox_min": [
        -2653.26416015625,
        -4056.075927734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.958984375,
        -3993.17724609375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000026226043701,
        -0.8660238981246948,
        2.5891913537634537e-05
      ],
      "plane_d": -4828.673828125,
      "bbox_min": [
        -2636.90087890625,
        -4056.075927734375,
        1112.623779296875
      ],
      "bbox_max": [
        -2631.958984375,
        -4053.222900390625,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2653.26416015625,
        -4012.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1057.6236572265625,
      "bbox_min": [
        -2664.091552734375,
        -4022.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.91748046875,
        -4012.0,
        1057.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        7.751265229671844e-07,
        0.0
      ],
      "plane_d": -3046.496826171875,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1057.5999755859375,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.286865234375,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3902.0,
      "bbox_min": [
        -3026.0,
        -3922.08203125,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2845.2509765625,
        -3902.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2829.04638671875,
        -3898.5556640625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2998.0,
      "bbox_min": [
        -2998.0,
        -3922.08203125,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3902.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2829.04638671875,
        -3903.140869140625,
        1052.623779296875
      ],
      "bbox_max": [
        -2823.678955078125,
        -3902.0,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.749237060546875,
        0.43256744742393494,
        0.5015268921852112
      ],
      "plane_d": -780.3825073242188,
      "bbox_min": [
        -2750.961181640625,
        -4247.66796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2671.367431640625,
        -4043.355712890625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        -0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2667.587646484375,
        -3984.21875,
        1052.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3974.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.800048828125,
      "bbox_min": [
        -3046.499755859375,
        -3974.800048828125,
        1052.623779296875
      ],
      "bbox_max": [
        -3041.499755859375,
        -3974.800048828125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        -0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2667.587646484375,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2772.989501953125,
        -3925.654541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3913.915283203125,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        -0.0
      ],
      "plane_d": -4404.92236328125,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2772.989501953125,
        -3903.140869140625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000314116477966,
        0.8660072684288025,
        0.0
      ],
      "plane_d": 1987.0889892578125,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2816.736328125,
        -3920.92041015625,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2824.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2824.999755859375,
        -3969.7685546875,
        1057.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4247.66796875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3898.5556640625,
        1187.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3902.0,
      "bbox_min": [
        -3026.0,
        -3922.08203125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2998.0,
      "bbox_min": [
        -2998.0,
        -3922.08203125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2998.0,
        -3902.0,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2651.219482421875,
        -3903.140869140625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9836496710777283,
        0.18009302020072937,
        0.0
      ],
      "plane_d": -2000.666015625,
      "bbox_min": [
        -2752.65576171875,
        -3925.654541015625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2751.3486328125,
        -3918.51513671875,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4050.7685546875,
      "bbox_min": [
        -3046.499755859375,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25882434844970703,
        0.9659245014190674,
        0.0
      ],
      "plane_d": 3390.9111328125,
      "bbox_min": [
        -3008.0888671875,
        -4247.66796875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2676.163330078125,
        -4050.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.749237060546875,
        0.43256744742393494,
        0.5015268921852112
      ],
      "plane_d": -780.3825073242188,
      "bbox_min": [
        -2725.0498046875,
        -4075.498291015625,
        1057.5999755859375
      ],
      "bbox_max": [
        -2676.163330078125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3003.1396484375,
      "bbox_min": [
        -3008.0888671875,
        -4082.66845703125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4054.818603515625,
      "bbox_min": [
        -3003.1396484375,
        -4082.66845703125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": -4389.66455078125,
      "bbox_min": [
        -3003.1396484375,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -4970.70166015625,
      "bbox_min": [
        -2995.999755859375,
        -4054.818603515625,
        1127.5999755859375
      ],
      "bbox_max": [
        -2991.970458984375,
        -4052.7685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        0.0
      ],
      "plane_d": -4970.70166015625,
      "bbox_min": [
        -3003.1396484375,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.89990234375,
        -4081.514404296875,
        1108.123779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        -0.4999813139438629,
        0.0
      ],
      "plane_d": -4389.66455078125,
      "bbox_min": [
        -2727.750732421875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2727.750732421875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -3003.1396484375,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4097.31396484375,
      "bbox_min": [
        -2939.89990234375,
        -4082.66845703125,
        1108.123779296875
      ],
      "bbox_max": [
        -2938.099853515625,
        -4082.2685546875,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4058.64013671875,
      "bbox_min": [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.248779296875,
        -4054.818603515625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.248779296875,
        -4054.818603515625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4058.64013671875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20791082084178925,
        -0.9781478047370911,
        0.0
      ],
      "plane_d": -4404.921875,
      "bbox_min": [
        -3046.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3903.140869140625,
        1185.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3003.1396484375,
      "bbox_min": [
        -3046.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2725.0498046875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4046.718505859375,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2711.91064453125,
        -4046.718505859375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4534572660923004,
        -0.8912780284881592,
        -0.0
      ],
      "plane_d": -4843.7958984375,
      "bbox_min": [
        -2725.0498046875,
        -4048.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2723.999755859375,
        -4048.234375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4012.0,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1057.6236572265625,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1057.623779296875
      ],
      "bbox_max": [
        -2660.6845703125,
        -4012.0,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2714.248779296875,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2725.0498046875,
        -4046.718505859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2714.248779296875,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3998.117919921875,
      "bbox_min": [
        -2859.99951171875,
        -4048.234130859375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3969.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4003.479248046875,
      "bbox_min": [
        -2800.323486328125,
        -4048.234130859375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3998.117919921875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2781.899658203125,
        -4048.234130859375,
        1108.123779296875
      ],
      "bbox_max": [
        -2725.0498046875,
        -4018.86865234375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": -339.047119140625,
      "bbox_min": [
        -2727.813720703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -2727.813720703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2727.813720703125,
        -4048.234130859375,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2825.051513671875,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2768.499755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4004.117919921875,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2768.499755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -414.185302734375,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1057.5999755859375
      ],
      "bbox_max": [
        -2790.03564453125,
        -4004.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2800.323486328125,
        -4012.66162109375,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -4004.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2800.323486328125,
        -4011.75341796875,
        1106.623779296875
      ],
      "bbox_max": [
        -2792.34521484375,
        -4004.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3891.818359375,
      "bbox_min": [
        -2796.9638671875,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2768.499755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2796.9638671875,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2796.9638671875,
        -4004.117919921875,
        1106.623779296875
      ],
      "bbox_max": [
        -2791.1904296875,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2859.99951171875,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.7685546875,
      "bbox_min": [
        -2850.55126953125,
        -3974.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5144957900047302,
        0.857492983341217
      ],
      "plane_d": 1132.95166015625,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2824.999755859375,
      "bbox_min": [
        -2824.999755859375,
        -3974.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1063.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3969.7685546875,
      "bbox_min": [
        -2824.999755859375,
        -3969.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2819.999755859375,
        -3969.7685546875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253882408142,
        -0.5,
        0.0
      ],
      "plane_d": -4439.951171875,
      "bbox_min": [
        -2999.930908203125,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -3979.57568359375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999081492424011,
        0.0,
        0.013554766774177551
      ],
      "plane_d": -2796.664306640625,
      "bbox_min": [
        -2805.999755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4009.93701171875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": -339.047119140625,
      "bbox_min": [
        -2730.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4046.827880859375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -2730.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2725.0498046875,
        -4046.827880859375,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375558018684387,
        -0.4258209764957428,
        0.5241067409515381
      ],
      "plane_d": -4361.27197265625,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2790.03564453125,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        -0.49999964237213135,
        0.0
      ],
      "plane_d": -4433.95068359375,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1057.5999755859375
      ],
      "bbox_max": [
        -2790.03564453125,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660257458686829,
        0.49999964237213135,
        0.0
      ],
      "plane_d": -414.185302734375,
      "bbox_min": [
        -2802.53564453125,
        -4019.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2794.96826171875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2802.53564453125,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2794.96826171875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2802.53564453125,
        -4017.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2796.75341796875,
        -4009.93701171875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075148224830627,
        -0.4084834158420563,
        -0.5766835808753967
      ],
      "plane_d": -3001.810546875,
      "bbox_min": [
        -2805.999755859375,
        -4041.419189453125,
        1076.123779296875
      ],
      "bbox_max": [
        -2790.03564453125,
        -4013.768310546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075143456459045,
        0.4084831476211548,
        -0.5766843557357788
      ],
      "plane_d": 282.208251953125,
      "bbox_min": [
        -2805.999755859375,
        -4019.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2799.071533203125,
        -4013.768310546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7375649213790894,
        0.4258262515068054,
        0.5240896940231323
      ],
      "plane_d": -937.85400390625,
      "bbox_min": [
        -2805.999755859375,
        -4019.7685546875,
        1106.623779296875
      ],
      "bbox_max": [
        -2800.22607421875,
        -4013.768310546875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": -4035.3193359375,
      "bbox_min": [
        -2999.930908203125,
        -4050.7685546875,
        1065.623779296875
      ],
      "bbox_max": [
        -2849.79296875,
        -3979.57568359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -2939.89990234375,
        -4020.66845703125,
        1065.623779296875
      ],
      "bbox_max": [
        -2849.79296875,
        -3979.57568359375,
        1137.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3571.1669921875,
      "bbox_min": [
        -2870.206787109375,
        -3984.7685546875,
        1065.623779296875
      ],
      "bbox_max": [
        -2849.79296875,
        -3979.57568359375,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2862.34423828125,
        -3980.7685546875,
        1069.623779296875
      ],
      "bbox_max": [
        -2857.65478515625,
        -3979.57568359375,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3998.117919921875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2850.55126953125,
        -3974.7685546875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999081492424011,
        0.013554766774177551
      ],
      "plane_d": 4003.479248046875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1076.123779296875
      ],
      "bbox_max": [
        -2926.499755859375,
        -3998.117919921875,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999080300331116,
        0.0,
        0.013563040643930435
      ],
      "plane_d": -2954.6591796875,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1108.123779296875
      ],
      "bbox_max": [
        -2939.499755859375,
        -4018.86865234375,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3003.1396484375,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -2992.185791015625,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8169679045677185,
        -0.5766832232475281
      ],
      "plane_d": 3891.818359375,
      "bbox_min": [
        -2951.499755859375,
        -4004.117919921875,
        1076.123779296875
      ],
      "bbox_max": [
        -2926.499755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.851658284664154,
        0.5240974426269531
      ],
      "plane_d": 2825.051513671875,
      "bbox_min": [
        -2951.499755859375,
        -4002.117919921875,
        1106.623779296875
      ],
      "bbox_max": [
        -2926.499755859375,
        -3998.117919921875,
        1113.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1069.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2850.55126953125,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -3571.1669921875,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2862.34423828125,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -3984.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -2884.999755859375,
        -3974.7685546875,
        1069.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3974.800048828125,
      "bbox_min": [
        -3046.499755859375,
        -4050.7685546875,
        1057.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -3974.800048828125,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660361766815186,
        0.4999813139438629,
        0.0
      ],
      "plane_d": -579.8052978515625,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4042.89697265625,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4042.89697265625,
        1139.873779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1127.5999755859375,
      "bbox_min": [
        -3008.0888671875,
        -4050.7685546875,
        1127.5999755859375
      ],
      "bbox_max": [
        -3003.1396484375,
        -4042.89697265625,
        1127.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6879106163978577,
        -0.6849433779716492,
        0.24006594717502594
      ],
      "plane_d": -658.194091796875,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4041.093017578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3442.946533203125,
        -4041.093017578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3899.365966796875,
        1052.623779296875
      ],
      "bbox_max": [
        -3293.08740234375,
        -3890.92822265625,
        1100.8765869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859943270683289,
        -0.6859943270683289,
        0.24253566563129425
      ],
      "plane_d": -671.7525634765625,
      "bbox_min": [
        -3549.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -416.77099609375,
      "bbox_min": [
        -3442.946533203125,
        -4041.188232421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3292.686279296875,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3899.76708984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3292.686279296875,
        -3890.92822265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3301.525146484375,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238786697387695,
        -0.38268566131591797
      ],
      "plane_d": -3150.5615234375,
      "bbox_min": [
        -3301.525146484375,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3826836347579956,
        -0.9238794445991516
      ],
      "plane_d": -456.76446533203125,
      "bbox_min": [
        -3301.525146484375,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": -3977.16259765625,
      "bbox_min": [
        -3301.525146484375,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238786697387695,
        -0.38268566131591797
      ],
      "plane_d": 4051.07275390625,
      "bbox_min": [
        -3301.525146484375,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3264.324462890625,
        -4004.589111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -3121.34130859375,
        -3928.12890625,
        1133.5926513671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1071.921630859375
      ],
      "bbox_max": [
        -3121.34130859375,
        -3937.5,
        1133.5926513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3150.0,
        -3947.0,
        1071.921630859375
      ],
      "bbox_max": [
        -3121.34130859375,
        -3937.5,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3564577102661133,
        0.0,
        0.9343115091323853
      ],
      "plane_d": 111.33392333984375,
      "bbox_min": [
        -3150.0,
        -3947.0,
        1071.921630859375
      ],
      "bbox_max": [
        -3121.948486328125,
        -3937.5,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3150.0,
        -3947.0,
        1075.1307373046875
      ],
      "bbox_max": [
        -3130.35986328125,
        -3947.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      "bbox_max": [
        -3122.400634765625,
        -3937.5,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -3169.5,
        -3968.556396484375,
        1082.623779296875
      ],
      "bbox_max": [
        -3124.0595703125,
        -3937.5,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3169.5,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3124.0595703125,
        -3937.5,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3165.8359375,
        -3956.48779296875,
        1093.228515625
      ],
      "bbox_max": [
        -3141.13671875,
        -3950.0,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.5999755859375,
      "bbox_min": [
        -3150.0,
        -3956.48779296875,
        1096.5999755859375
      ],
      "bbox_max": [
        -3142.498046875,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3169.5,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3133.385498046875,
        -3937.5,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3169.5,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3136.854736328125,
        -3947.0,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3160.0,
        -3950.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3150.0,
        -3947.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.5999755859375,
      "bbox_min": [
        -3160.0,
        -3950.0,
        1096.5999755859375
      ],
      "bbox_max": [
        -3150.0,
        -3947.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1090.413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3149.70458984375,
        -3960.0,
        1086.5421142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1096.5999755859375,
      "bbox_min": [
        -3160.0,
        -3947.0,
        1096.5999755859375
      ],
      "bbox_max": [
        -3150.0,
        -3937.5,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3147.131591796875,
        -3958.887451171875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3169.5,
      "bbox_min": [
        -3179.233642578125,
        -3978.231689453125,
        1082.623779296875
      ],
      "bbox_max": [
        -3148.417724609375,
        -3960.0,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3179.233642578125,
        -3976.46484375,
        1102.623779296875
      ],
      "bbox_max": [
        -3169.5,
        -3968.55615234375,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5082.8330078125,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1082.623779296875
      ],
      "bbox_max": [
        -3191.206787109375,
        -3983.69287109375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3207.47998046875,
        -3997.268798828125,
        1086.5999755859375
      ],
      "bbox_max": [
        -3191.951416015625,
        -3983.69287109375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": 3224.4716796875,
      "bbox_min": [
        -3301.525146484375,
        -3948.83984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3937.5,
      "bbox_min": [
        -3143.122314453125,
        -3940.84619140625,
        1070.176513671875
      ],
      "bbox_max": [
        -3117.37451171875,
        -3937.5,
        1080.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3564577102661133,
        0.0,
        0.9343115091323853
      ],
      "plane_d": 111.33392333984375,
      "bbox_min": [
        -3143.122314453125,
        -3940.84619140625,
        1070.176513671875
      ],
      "bbox_max": [
        -3117.37451171875,
        -3937.5,
        1079.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -3119.999755859375,
      "bbox_min": [
        -3301.525146484375,
        -3937.5,
        1052.623779296875
      ],
      "bbox_max": [
        -3088.0,
        -3857.5,
        1120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3120.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3877.0,
      "bbox_min": [
        -3120.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3088.0,
      "bbox_min": [
        -3120.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3108.0,
      "bbox_min": [
        -3120.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3120.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3108.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3887.0,
      "bbox_min": [
        -3120.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3118.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3908.0,
      "bbox_min": [
        -3120.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3118.0,
        -3908.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3908.0,
      "bbox_min": [
        -3118.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3108.0,
        -3908.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4299336075782776,
        0.9028605818748474
      ],
      "plane_d": -2643.171630859375,
      "bbox_min": [
        -3108.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3108.0,
        -3887.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3877.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3098.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3908.0,
      "bbox_min": [
        -3098.0,
        -3908.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3908.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.5999755859375,
      "bbox_min": [
        -3108.0,
        -3930.641845703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3908.0,
        1066.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 3239.999755859375,
      "bbox_min": [
        -3301.525146484375,
        -3937.5,
        1052.623779296875
      ],
      "bbox_max": [
        -3120.0,
        -3857.5,
        1120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3301.525146484375,
        -3937.5,
        1052.623779296875
      ],
      "bbox_max": [
        -3240.0,
        -3887.0,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3240.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3240.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3887.0,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3240.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1414213627576828,
        0.9899495244026184,
        0.0
      ],
      "plane_d": 4326.927734375,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3240.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6592567563056946,
        0.7519178986549377,
        0.0
      ],
      "plane_d": 781.036376953125,
      "bbox_min": [
        -3288.898193359375,
        -3913.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3268.0,
        -3901.268798828125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888453006744385,
        -0.6145919561386108,
        0.0
      ],
      "plane_d": 195.33837890625,
      "bbox_min": [
        -3288.898193359375,
        -3903.55517578125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3287.116943359375,
        -3901.268798828125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7888453006744385,
        -0.6145919561386108,
        0.0
      ],
      "plane_d": 195.33837890625,
      "bbox_min": [
        -3287.116943359375,
        -3901.268798828125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3276.0,
        -3887.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3240.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3120.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1075.5999755859375,
      "bbox_min": [
        -3240.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3120.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3887.0,
      "bbox_min": [
        -3240.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3120.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3908.0,
      "bbox_min": [
        -3240.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3120.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3210.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3150.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3210.0,
      "bbox_min": [
        -3210.0,
        -3908.0,
        1075.5999755859375
      ],
      "bbox_max": [
        -3210.0,
        -3887.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1086.5999755859375,
      "bbox_min": [
        -3196.198974609375,
        -3998.226806640625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3193.11865234375,
        -3996.25439453125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.917862057685852,
        -0.14546944200992584,
        0.36928024888038635
      ],
      "plane_d": 2066.38818359375,
      "bbox_min": [
        -3479.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4032.349609375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541234850883484,
        -0.7563877701759338,
        0.0
      ],
      "plane_d": -930.5595703125,
      "bbox_min": [
        -3479.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4032.349609375,
        1121.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3431.343017578125,
      "bbox_min": [
        -3442.946533203125,
        -4200.58203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3438.83251953125,
        -4200.58203125,
        1094.623779296875
      ],
      "bbox_max": [
        -3434.6865234375,
        -4196.435546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3431.343017578125,
        -4192.00244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4043.953125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5285.8330078125,
      "bbox_min": [
        -3431.343017578125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4043.953125,
        1102.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3431.343017578125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3431.343017578125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.5999755859375,
      "bbox_min": [
        -3411.343017578125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541262865066528,
        -0.7563854455947876,
        0.0
      ],
      "plane_d": -910.540283203125,
      "bbox_min": [
        -3391.688720703125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.5999755859375,
      "bbox_min": [
        -3391.688720703125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7563903331756592,
        0.6541206240653992,
        0.0
      ],
      "plane_d": 5271.5087890625,
      "bbox_min": [
        -3391.688720703125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563903331756592,
        -0.6541206240653992,
        0.0
      ],
      "plane_d": -5241.4931640625,
      "bbox_min": [
        -3391.688720703125,
        -4152.08349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3418773114681244,
        0.29565292596817017,
        -0.892025351524353
      ],
      "plane_d": 3329.61865234375,
      "bbox_min": [
        -3391.688720703125,
        -4152.08349609375,
        1061.5999755859375
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3676980435848236,
        -0.3179825246334076,
        -0.8738908767700195
      ],
      "plane_d": -1620.283447265625,
      "bbox_min": [
        -3374.424560546875,
        -4137.1533203125,
        1061.5999755859375
      ],
      "bbox_max": [
        -3355.903076171875,
        -4117.32177734375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3411.343017578125,
      "bbox_min": [
        -3411.343017578125,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39224565029144287,
        -0.39224565029144287,
        0.8320376873016357
      ],
      "plane_d": -3828.726806640625,
      "bbox_min": [
        -3411.343017578125,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071024775505066,
        -0.707111120223999,
        -0.0
      ],
      "plane_d": -5290.283203125,
      "bbox_min": [
        -3411.343017578125,
        -4106.60546875,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4076.0,
      "bbox_min": [
        -3405.5859375,
        -4100.24267578125,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.343017578125,
      "bbox_min": [
        -3383.46435546875,
        -4100.24267578125,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4096.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070661187171936,
        -0.707147479057312,
        0.0
      ],
      "plane_d": -505.64306640625,
      "bbox_min": [
        -3383.46435546875,
        -4098.12109375,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4096.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4076.0,
      "bbox_min": [
        -3411.343017578125,
        -4076.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3405.5859375,
        -4076.0,
        1074.5997314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.343017578125,
      "bbox_min": [
        -3381.343017578125,
        -4100.24267578125,
        1074.5997314453125
      ],
      "bbox_max": [
        -3381.343017578125,
        -4096.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4657464325428009,
        0.884918212890625
      ],
      "plane_d": 961.5149536132812,
      "bbox_min": [
        -3411.343017578125,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3406.0,
      "bbox_min": [
        -3406.0,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4100.5,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.343017578125,
      "bbox_min": [
        -3381.343017578125,
        -4110.0,
        1071.5999755859375
      ],
      "bbox_max": [
        -3381.343017578125,
        -4103.384765625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.343017578125,
      "bbox_min": [
        -3411.343017578125,
        -4110.0,
        1071.885498046875
      ],
      "bbox_max": [
        -3381.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4076.0,
      "bbox_min": [
        -3411.343017578125,
        -4076.0,
        1071.885498046875
      ],
      "bbox_max": [
        -3405.5859375,
        -4076.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3421.343017578125,
      "bbox_min": [
        -3431.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3360.69287109375,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3411.343017578125,
      "bbox_min": [
        -3421.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3360.69287109375,
        -4054.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 448.770263671875,
      "bbox_min": [
        -3421.343017578125,
        -4056.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3420.319580078125,
        -4054.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4128.00830078125,
      "bbox_min": [
        -3421.343017578125,
        -4128.00830078125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3411.343017578125,
        -4128.00830078125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4128.00830078125,
      "bbox_min": [
        -3411.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3360.69287109375,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7563902735710144,
        0.6541206240653992,
        0.0
      ],
      "plane_d": 5257.830078125,
      "bbox_min": [
        -3381.343017578125,
        -4143.13623046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3360.69287109375,
        -4128.00830078125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563902735710144,
        -0.6541206240653992,
        0.0
      ],
      "plane_d": -5247.8251953125,
      "bbox_min": [
        -3368.11572265625,
        -4136.591796875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3360.69287109375,
        -4128.00830078125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3381.343017578125,
      "bbox_min": [
        -3411.343017578125,
        -4128.00830078125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3368.11572265625,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3373.775390625,
      "bbox_min": [
        -3381.343017578125,
        -4128.00830078125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3368.11572265625,
        -4094.976318359375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563902735710144,
        -0.6541206240653992,
        0.0
      ],
      "plane_d": -5247.8251953125,
      "bbox_min": [
        -3373.775390625,
        -4128.00830078125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3368.11572265625,
        -4121.4638671875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4110.0,
      "bbox_min": [
        -3381.343017578125,
        -4110.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3373.775390625,
        -4094.976318359375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071911096572876,
        0.707022488117218,
        0.0
      ],
      "plane_d": 504.708251953125,
      "bbox_min": [
        -3381.343017578125,
        -4096.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3380.319580078125,
        -4094.976318359375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4076.0,
      "bbox_min": [
        -3411.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3400.319580078125,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -477.0546875,
      "bbox_min": [
        -3401.343017578125,
        -4076.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3400.319580078125,
        -4074.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4128.00830078125,
      "bbox_min": [
        -3431.343017578125,
        -4128.00830078125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3421.343017578125,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -434.628173828125,
      "bbox_min": [
        -3431.343017578125,
        -4046.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3430.319580078125,
        -4044.9765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3434.6865234375,
        -4201.578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1102.6240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3434.6865234375,
        -4201.578125,
        1096.7835693359375
      ],
      "bbox_max": [
        -3433.690185546875,
        -4200.58203125,
        1102.6231689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3424.76611328125,
        -4198.61474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1080.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6665334701538086,
        0.6665472984313965,
        0.3338381052017212
      ],
      "plane_d": 4631.18603515625,
      "bbox_min": [
        -3424.76611328125,
        -4198.61474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.53857421875,
        -4124.4921875,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -5331.5146484375,
      "bbox_min": [
        -3424.76611328125,
        -4198.61474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.22705078125,
        -4131.0341796875,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6688962578773499,
        0.6624125838279724,
        0.3373238742351532
      ],
      "plane_d": 4618.2919921875,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.22705078125,
        -4131.0341796875,
        1072.6136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.5999755859375,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.26416015625,
        -4132.44970703125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563573718070984,
        -0.6541587710380554,
        0.0
      ],
      "plane_d": -5241.5400390625,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3347.26416015625,
        -4132.44970703125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3676820397377014,
        -0.31800106167793274,
        -0.8738908767700195
      ],
      "plane_d": -1620.306396484375,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.81494140625,
        -4132.44970703125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34186241030693054,
        0.29567018151283264,
        -0.892025351524353
      ],
      "plane_d": 3329.639892578125,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3366.23828125,
        -4146.91943359375,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.5999755859375,
      "bbox_min": [
        -3380.0,
        -4164.03662109375,
        1058.4749755859375
      ],
      "bbox_max": [
        -3371.518310546875,
        -4155.865234375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541947722434998,
        -0.7563261389732361,
        0.0
      ],
      "plane_d": -935.062744140625,
      "bbox_min": [
        -3380.0,
        -4159.89990234375,
        1058.4749755859375
      ],
      "bbox_max": [
        -3375.33544921875,
        -4155.865234375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541947722434998,
        -0.7563261389732361,
        0.0
      ],
      "plane_d": -935.062744140625,
      "bbox_min": [
        -3380.0,
        -4159.89990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3375.33544921875,
        -4155.865234375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2643769681453705,
        0.26181721687316895,
        -0.9282006621360779
      ],
      "plane_d": 2963.95458984375,
      "bbox_min": [
        -3354.266845703125,
        -4136.681640625,
        1072.5999755859375
      ],
      "bbox_max": [
        -3348.65087890625,
        -4131.0341796875,
        1072.6136474609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1062.5999755859375,
      "bbox_min": [
        -3424.76611328125,
        -4198.61474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3377.933349609375,
        -4156.39990234375,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6560397148132324,
        -0.7547264695167542,
        0.0
      ],
      "plane_d": -926.360595703125,
      "bbox_min": [
        -3418.15380859375,
        -4198.61474609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3396.503662109375,
        -4172.81103515625,
        1062.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7547333240509033,
        0.6560317873954773,
        1.8470072973286733e-05
      ],
      "plane_d": 5305.513671875,
      "bbox_min": [
        -3402.57421875,
        -4179.794921875,
        1052.623779296875
      ],
      "bbox_max": [
        -3396.503662109375,
        -4172.81103515625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547353506088257,
        0.6560294032096863,
        0.0
      ],
      "plane_d": 5315.529296875,
      "bbox_min": [
        -3411.59765625,
        -4195.8603515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3401.47412109375,
        -4186.35498046875,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.754712700843811,
        -0.6560553908348083,
        0.0
      ],
      "plane_d": -5325.5615234375,
      "bbox_min": [
        -3411.59765625,
        -4195.8603515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3409.0380859375,
        -4192.916015625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547096610069275,
        0.6560589075088501,
        0.0
      ],
      "plane_d": 5315.5654296875,
      "bbox_min": [
        -3417.701904296875,
        -4193.87158203125,
        1062.5999755859375
      ],
      "bbox_max": [
        -3377.933349609375,
        -4156.39990234375,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7547248005867004,
        -0.65604168176651,
        0.0
      ],
      "plane_d": -5325.54443359375,
      "bbox_min": [
        -3417.701904296875,
        -4193.87158203125,
        1062.5999755859375
      ],
      "bbox_max": [
        -3404.935791015625,
        -4179.3525390625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3417.701904296875,
        -4191.8779296875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3404.935791015625,
        -4179.3525390625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26306381821632385,
        -0.2621646225452423,
        -0.9284756779670715
      ],
      "plane_d": -983.8545532226562,
      "bbox_min": [
        -3391.1279296875,
        -4167.79296875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3377.933349609375,
        -4156.39990234375,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2643769681453705,
        0.26181721687316895,
        -0.9282006621360779
      ],
      "plane_d": 2963.95458984375,
      "bbox_min": [
        -3354.266845703125,
        -4136.65673828125,
        1072.5999755859375
      ],
      "bbox_max": [
        -3341.851806640625,
        -4124.4921875,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6355183124542236,
        0.6299405097961426,
        0.44642046093940735
      ],
      "plane_d": 4244.458984375,
      "bbox_min": [
        -3391.1279296875,
        -4167.79296875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3341.851806640625,
        -4124.4921875,
        1080.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6335403919219971,
        -0.6313741207122803,
        0.4472060799598694
      ],
      "plane_d": -5258.2333984375,
      "bbox_min": [
        -3391.1279296875,
        -4167.79296875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7083191871643066,
        0.7058923840522766,
        0.0
      ],
      "plane_d": 5337.56884765625,
      "bbox_min": [
        -3389.611328125,
        -4165.82568359375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3389.611328125,
        -4165.73095703125,
        1080.5999755859375
      ],
      "bbox_max": [
        -3384.736572265625,
        -4160.94482421875,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7103103399276733,
        -0.7038887143135071,
        0.0
      ],
      "plane_d": -5283.3740234375,
      "bbox_min": [
        -3348.97119140625,
        -4131.3486328125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3348.970947265625,
        -4130.59619140625,
        1080.5999755859375
      ],
      "bbox_max": [
        -3344.110595703125,
        -4125.80078125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5261.6787109375,
      "bbox_min": [
        -3411.724853515625,
        -4036.483154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.582763671875,
        -4024.89990234375,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 436.770751953125,
      "bbox_min": [
        -3411.724853515625,
        -4036.483154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.582763671875,
        -4024.89990234375,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.5,
      "bbox_min": [
        -3411.462646484375,
        -4036.483154296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.582763671875,
        -4026.279541015625,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 5251.6787109375,
      "bbox_min": [
        -3400.71533203125,
        -4029.412109375,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.582763671875,
        -4026.279541015625,
        1060.8275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5231.6787109375,
      "bbox_min": [
        -3411.724853515625,
        -4032.059814453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": 5221.6787109375,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -446.770751953125,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 436.770751953125,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1071.5,
      "bbox_min": [
        -3390.51171875,
        -4015.27001953125,
        1071.5
      ],
      "bbox_max": [
        -3376.36962890625,
        -4001.1279296875,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 436.770751953125,
      "bbox_min": [
        -3411.724853515625,
        -4032.059814453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.582763671875,
        -4022.341064453125,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -446.770751953125,
      "bbox_min": [
        -3411.724853515625,
        -4032.059814453125,
        1060.8275146484375
      ],
      "bbox_max": [
        -3397.582763671875,
        -4029.412109375,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -5261.6787109375,
      "bbox_min": [
        -3411.724853515625,
        -4029.67431640625,
        1070.813232421875
      ],
      "bbox_max": [
        -3411.462646484375,
        -4029.412109375,
        1071.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3502.01513671875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3902.59228515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3438.244384765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3902.59228515625,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1066.5999755859375
      ],
      "bbox_max": [
        -3083.468505859375,
        -3902.59228515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -3163.27734375,
        -3965.86669921875,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3906.362060546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3098.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3906.362060546875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3908.0,
      "bbox_min": [
        -3089.89404296875,
        -3908.0,
        1081.9093017578125
      ],
      "bbox_max": [
        -3088.0,
        -3906.362060546875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3088.0,
      "bbox_min": [
        -3089.89404296875,
        -3908.0,
        1081.9095458984375
      ],
      "bbox_max": [
        -3088.0,
        -3906.362060546875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3089.89404296875,
        -3908.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3088.0,
        -3906.362060546875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3915.010009765625,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3137.0380859375,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3915.010009765625,
        1097.8330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3108.0,
      "bbox_min": [
        -3137.0380859375,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3915.010009765625,
        1097.8330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3137.0380859375,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3108.0,
        -3930.11328125,
        1097.8330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3119.999755859375,
      "bbox_min": [
        -3120.924560546875,
        -3935.350830078125,
        1085.1883544921875
      ],
      "bbox_max": [
        -3120.0,
        -3930.11328125,
        1097.8330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -3119.999755859375,
      "bbox_min": [
        -3121.341064453125,
        -3937.5,
        1078.4808349609375
      ],
      "bbox_max": [
        -3120.0,
        -3934.528564453125,
        1085.5400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238786697387695,
        -0.38268566131591797
      ],
      "plane_d": 4051.07275390625,
      "bbox_min": [
        -3121.341064453125,
        -3937.5,
        1078.4808349609375
      ],
      "bbox_max": [
        -3120.0,
        -3935.205322265625,
        1085.5400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9238786697387695,
        0.38268566131591797
      ],
      "plane_d": 3224.4716796875,
      "bbox_min": [
        -3121.341064453125,
        -3937.5,
        1078.4808349609375
      ],
      "bbox_max": [
        -3120.0,
        -3936.870849609375,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3564577102661133,
        0.0,
        0.9343115091323853
      ],
      "plane_d": 111.33392333984375,
      "bbox_min": [
        -3130.35986328125,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3108.0,
        -3937.5,
        1075.1307373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1086.5999755859375,
      "bbox_min": [
        -3108.0,
        -3941.97265625,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3915.010009765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.5999755859375,
      "bbox_min": [
        -3108.0,
        -3941.97265625,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3921.993896484375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3937.5,
      "bbox_min": [
        -3108.0,
        -3941.97265625,
        1080.623779296875
      ],
      "bbox_max": [
        -3098.0,
        -3937.5,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.623779296875,
      "bbox_min": [
        -3108.0,
        -3941.97265625,
        1080.623779296875
      ],
      "bbox_max": [
        -3098.0,
        -3937.5,
        1080.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3126.57080078125,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.5999755859375,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1085.8109130859375
      ],
      "bbox_max": [
        -3140.0,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1085.8109130859375
      ],
      "bbox_max": [
        -3149.70458984375,
        -3956.48779296875,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3150.0,
        -3960.0,
        1085.8109130859375
      ],
      "bbox_max": [
        -3149.70458984375,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3438.244384765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.3826853334903717,
        0.9238787889480591,
        0.0
      ],
      "plane_d": 2758.4794921875,
      "bbox_min": [
        -3395.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -4239.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3395.499755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": -3242.712158203125,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.9443359375,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": -1945.72900390625,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3167.36328125,
        -4249.7685546875,
        1063.970458984375
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1063.9708251953125
      ],
      "bbox_max": [
        -3222.63623046875,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3222.63623046875,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.63623046875,
        -4239.7685546875,
        1063.9708251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3169.999755859375,
      "bbox_min": [
        -3169.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3167.36328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4239.7685546875,
        1063.970458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3395.499755859375,
        -4248.2685546875,
        1117.196044921875
      ],
      "bbox_max": [
        -3386.999755859375,
        -4239.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3083.468505859375,
      "bbox_min": [
        -3438.244384765625,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1086.599853515625,
      "bbox_min": [
        -3438.244384765625,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -3931.36865234375,
        1121.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3086.468505859375,
      "bbox_min": [
        -3421.765380859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -3932.66552734375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4060.0,
      "bbox_min": [
        -3086.468505859375,
        -4060.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3083.468505859375,
        -4060.0,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -3421.765380859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3932.66552734375,
        1086.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4060.0,
      "bbox_min": [
        -3132.453369140625,
        -4060.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3937.650146484375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3947.0,
      "bbox_min": [
        -3119.630615234375,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3937.650146484375,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3564577102661133,
        0.0,
        0.9343115091323853
      ],
      "plane_d": 111.33392333984375,
      "bbox_min": [
        -3119.63037109375,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3937.650146484375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.623779296875,
      "bbox_min": [
        -3113.2578125,
        -3947.0,
        1066.5999755859375
      ],
      "bbox_max": [
        -3098.0,
        -3937.650146484375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3113.2578125,
        -3947.0,
        1080.623779296875
      ],
      "bbox_max": [
        -3108.0,
        -3941.97265625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6355183124542236,
        0.6299405097961426,
        0.44642046093940735
      ],
      "plane_d": 4244.458984375,
      "bbox_min": [
        -3421.020751953125,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7103103399276733,
        -0.7038887143135071,
        0.0
      ],
      "plane_d": -5283.3740234375,
      "bbox_min": [
        -3421.020751953125,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3344.8671875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4129.38525390625,
        1080.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2454.721435546875,
      "bbox_min": [
        -3285.761962890625,
        -4193.26904296875,
        1075.39990234375
      ],
      "bbox_max": [
        -3282.76171875,
        -4188.99853515625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 2218.78515625,
      "bbox_min": [
        -3285.761962890625,
        -4193.26904296875,
        1075.39990234375
      ],
      "bbox_max": [
        -3282.76171875,
        -4188.99853515625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6651487350463867,
        0.6651487350463867,
        0.33934393525123596
      ],
      "plane_d": 4614.98193359375,
      "bbox_min": [
        -3339.73388671875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4135.7568359375,
        1062.6473388671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3337.302490234375,
        -4190.74609375,
        1052.623779296875
      ],
      "bbox_max": [
        -3285.26171875,
        -4138.1123046875,
        1053.95556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7086345553398132,
        0.705575168132782,
        -0.0008646472706459463
      ],
      "plane_d": 565.81591796875,
      "bbox_min": [
        -3337.302490234375,
        -4145.33447265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3330.1123046875,
        -4138.1123046875,
        1053.1907958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705562174320221,
        -0.7086475491523743,
        -0.0008191458764486015
      ],
      "plane_d": -577.010498046875,
      "bbox_min": [
        -3337.302490234375,
        -4138.23095703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.183349609375,
        -4138.1123046875,
        1053.071044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4232.6650390625,
        1062.6473388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.665036678314209,
        0.6585969924926758,
        0.3521025776863098
      ],
      "plane_d": 4573.732421875,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4131.3486328125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6651487350463867,
        0.6651487350463867,
        0.33934393525123596
      ],
      "plane_d": 4614.98193359375,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4135.7763671875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071841359138489,
        -0.7070294618606567,
        -0.0
      ],
      "plane_d": -5295.1064453125,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4136.9404296875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3351.107421875,
        -4205.75,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4136.9404296875,
        1077.349365234375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3343.800048828125,
        -4205.75,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4138.23095703125,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.5,
      "bbox_min": [
        -3343.800048828125,
        -4151.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3330.262451171875,
        -4138.23095703125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6713940501213074,
        0.6649112105369568,
        0.32729673385620117
      ],
      "plane_d": 4647.7470703125,
      "bbox_min": [
        -3341.637939453125,
        -4150.279296875,
        1062.5
      ],
      "bbox_max": [
        -3332.734619140625,
        -4140.734375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6691474318504333,
        0.6691474318504333,
        0.32323914766311646
      ],
      "plane_d": 4662.142578125,
      "bbox_min": [
        -3341.637939453125,
        -4147.80517578125,
        1062.5
      ],
      "bbox_max": [
        -3332.734619140625,
        -4140.734375,
        1070.0885009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.705562174320221,
        -0.7086475491523743,
        -0.0008191458764486015
      ],
      "plane_d": -577.010498046875,
      "bbox_min": [
        -3343.800048828125,
        -4151.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3330.262451171875,
        -4138.23095703125,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7045431137084961,
        -0.709661066532135,
        0.0
      ],
      "plane_d": -585.481201171875,
      "bbox_min": [
        -3343.800048828125,
        -4144.7001953125,
        1052.623779296875
      ],
      "bbox_max": [
        -3339.805419921875,
        -4140.734375,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7086345553398132,
        0.705575168132782,
        -0.0008646472706459463
      ],
      "plane_d": 565.81591796875,
      "bbox_min": [
        -3336.699951171875,
        -4151.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3330.262451171875,
        -4145.333984375,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7097045183181763,
        0.7044995427131653,
        0.0
      ],
      "plane_d": 556.8701171875,
      "bbox_min": [
        -3336.699951171875,
        -4151.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.734619140625,
        -4147.80517578125,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2454.721435546875,
      "bbox_min": [
        -3285.76171875,
        -4205.75,
        1076.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4202.3486328125,
        1077.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3285.76171875,
      "bbox_min": [
        -3285.76171875,
        -4202.7490234375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3285.76171875,
        -4202.3486328125,
        1077.349365234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1067.5,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3282.76171875,
        -4137.3896484375,
        1082.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1067.5
      ],
      "bbox_max": [
        -3282.76171875,
        -4137.3896484375,
        1082.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1067.5
      ],
      "bbox_max": [
        -3282.76171875,
        -4195.74853515625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3337.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1067.5
      ],
      "bbox_max": [
        -3337.0,
        -4225.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4225.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1067.5
      ],
      "bbox_max": [
        -3337.0,
        -4225.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3347.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1067.5
      ],
      "bbox_max": [
        -3347.0,
        -4225.0,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 2218.78515625,
      "bbox_min": [
        -3292.76171875,
        -4239.7685546875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4195.74853515625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2603455185890198,
        0.2650439739227295,
        -0.9284244179725647
      ],
      "plane_d": 1240.3663330078125,
      "bbox_min": [
        -3412.49951171875,
        -4239.7685546875,
        1067.5
      ],
      "bbox_max": [
        -3332.222412109375,
        -4152.14306640625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26086029410362244,
        0.2653508484363556,
        -0.9281923174858093
      ],
      "plane_d": 1239.6800537109375,
      "bbox_min": [
        -3384.055419921875,
        -4239.7685546875,
        1072.5999755859375
      ],
      "bbox_max": [
        -3352.490478515625,
        -4201.68212890625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26306381821632385,
        -0.2621646225452423,
        -0.9284756779670715
      ],
      "plane_d": -983.8545532226562,
      "bbox_min": [
        -3412.49951171875,
        -4201.7548828125,
        1067.5
      ],
      "bbox_max": [
        -3332.222412109375,
        -4152.14306640625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7086856365203857,
        -0.7055244445800781,
        -1.1089560757682193e-05
      ],
      "plane_d": -5330.234375,
      "bbox_min": [
        -3377.923095703125,
        -4201.7548828125,
        1067.5
      ],
      "bbox_max": [
        -3332.222412109375,
        -4152.14306640625,
        1076.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6541275382041931,
        0.7563842535018921,
        -6.575742190761957e-06
      ],
      "plane_d": 970.0958862304688,
      "bbox_min": [
        -3359.783447265625,
        -4179.07177734375,
        1067.5
      ],
      "bbox_max": [
        -3332.222412109375,
        -4152.14306640625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7261789441108704,
        -0.6875057220458984,
        -0.00017119180120062083
      ],
      "plane_d": -5282.5654296875,
      "bbox_min": [
        -3359.783447265625,
        -4179.07177734375,
        1067.5
      ],
      "bbox_max": [
        -3332.222412109375,
        -4152.14306640625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7277738451957703,
        0.6858171224594116,
        0.00017122454300988466
      ],
      "plane_d": 5303.45654296875,
      "bbox_min": [
        -3359.783447265625,
        -4179.07177734375,
        1069.1522216796875
      ],
      "bbox_max": [
        -3349.3388671875,
        -4167.98828125,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5331.51416015625,
      "bbox_min": [
        -3377.923095703125,
        -4167.0,
        1072.5894775390625
      ],
      "bbox_max": [
        -3372.89990234375,
        -4161.9765625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7086856365203857,
        -0.7055244445800781,
        -1.1089560757682193e-05
      ],
      "plane_d": -5330.234375,
      "bbox_min": [
        -3412.49951171875,
        -4201.7548828125,
        1067.5
      ],
      "bbox_max": [
        -3338.300048828125,
        -4161.9775390625,
        1072.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6541275382041931,
        0.7563842535018921,
        -6.575742190761957e-06
      ],
      "plane_d": 970.0958862304688,
      "bbox_min": [
        -3359.782470703125,
        -4179.07080078125,
        1067.5
      ],
      "bbox_max": [
        -3345.884033203125,
        -4165.08935546875,
        1069.322509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7018858194351196,
        -0.7122894525527954,
        1.7714228306431323e-05
      ],
      "plane_d": -610.6495361328125,
      "bbox_min": [
        -3359.782470703125,
        -4167.98828125,
        1067.5
      ],
      "bbox_max": [
        -3356.84033203125,
        -4165.08935546875,
        1069.1522216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3412.49951171875,
        -4200.46240234375,
        1067.5
      ],
      "bbox_max": [
        -3372.89990234375,
        -4161.9775390625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547096610069275,
        0.6560589075088501,
        0.0
      ],
      "plane_d": 5315.5654296875,
      "bbox_min": [
        -3412.49951171875,
        -4200.46240234375,
        1067.5
      ],
      "bbox_max": [
        -3372.89990234375,
        -4161.9775390625,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7547248005867004,
        -0.65604168176651,
        0.0
      ],
      "plane_d": -5325.54443359375,
      "bbox_min": [
        -3412.49951171875,
        -4200.46240234375,
        1067.5
      ],
      "bbox_max": [
        -3397.490234375,
        -4191.8779296875,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6560397148132324,
        -0.7547264695167542,
        0.0
      ],
      "plane_d": -936.360595703125,
      "bbox_min": [
        -3405.037109375,
        -4200.46240234375,
        1067.5
      ],
      "bbox_max": [
        -3397.490234375,
        -4193.90234375,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5331.51416015625,
      "bbox_min": [
        -3377.922119140625,
        -4167.0,
        1067.5
      ],
      "bbox_max": [
        -3372.89990234375,
        -4161.9775390625,
        1072.594482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7083191871643066,
        0.7058923840522766,
        0.0
      ],
      "plane_d": 5337.56884765625,
      "bbox_min": [
        -3386.263916015625,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4164.630859375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.5999755859375,
      "bbox_min": [
        -3386.263916015625,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4165.0751953125,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6335403919219971,
        -0.6313741207122803,
        0.4472060799598694
      ],
      "plane_d": -5258.2333984375,
      "bbox_min": [
        -3386.263916015625,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4165.73095703125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3350.37255859375,
        -4218.2294921875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4201.7041015625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3350.37255859375,
        -4210.8701171875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3340.276611328125,
        -4201.7041015625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7010470628738403,
        -0.7131150364875793,
        0.0
      ],
      "plane_d": -649.029052734375,
      "bbox_min": [
        -3350.37255859375,
        -4203.80712890625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3348.2333984375,
        -4201.7041015625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6270396113395691,
        0.6378400325775146,
        0.4471929967403412
      ],
      "plane_d": 96.40899658203125,
      "bbox_min": [
        -3384.055419921875,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4201.68212890625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7010470628738403,
        -0.7131150364875793,
        0.0
      ],
      "plane_d": -649.029052734375,
      "bbox_min": [
        -3381.93408203125,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4202.40478515625,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3372.857666015625,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4210.38720703125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4225.0,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4215.39599609375,
        1080.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3336.0,
        -4225.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4215.39599609375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4235.0,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3336.0,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4235.0,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3347.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3347.0,
        -4225.0,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3371.0078125,
        -4239.7685546875,
        1080.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4209.6884765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1080.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4213.97900390625,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4225.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1080.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4235.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1080.5999755859375
      ],
      "bbox_max": [
        -3337.0,
        -4225.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3347.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1080.5999755859375
      ],
      "bbox_max": [
        -3347.0,
        -4225.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3342.94775390625,
        -4213.21923828125,
        1080.7877197265625
      ],
      "bbox_max": [
        -3339.900634765625,
        -4209.7314453125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3300.800048828125,
        -4194.9736328125,
        1076.5999755859375
      ],
      "bbox_max": [
        -3295.76171875,
        -4189.23388671875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3349.693603515625,
        -4213.97900390625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3300.800048828125,
        -4164.630859375,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7117072939872742,
        -0.7024762034416199,
        0.0
      ],
      "plane_d": -5297.07421875,
      "bbox_min": [
        -3349.693603515625,
        -4213.97900390625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3300.800048828125,
        -4172.5888671875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5865098237991333,
        -0.8099421262741089,
        0.0
      ],
      "plane_d": -1454.8795166015625,
      "bbox_min": [
        -3349.693603515625,
        -4213.97900390625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3321.5,
        -4172.5888671875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.656984269618988,
        -0.753904402256012,
        0.0
      ],
      "plane_d": -961.71875,
      "bbox_min": [
        -3349.693603515625,
        -4210.0654296875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3321.5,
        -4172.5888671875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7051839232444763,
        0.7090244889259338,
        0.0
      ],
      "plane_d": 5321.234375,
      "bbox_min": [
        -3345.052001953125,
        -4210.0654296875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3321.5,
        -4184.7890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3345.052001953125,
        -4210.0654296875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3328.035400390625,
        -4184.7890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7090442180633545,
        0.7051639556884766,
        -4.60024921267177e-06
      ],
      "plane_d": 598.4434814453125,
      "bbox_min": [
        -3345.052001953125,
        -4201.79248046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3328.035400390625,
        -4184.7890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6889576315879822,
        -0.6830261945724487,
        0.24251310527324677
      ],
      "plane_d": -5428.02783203125,
      "bbox_min": [
        -3334.408447265625,
        -4201.79248046875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3331.906982421875,
        -4200.34033203125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7090144157409668,
        -0.7051939964294434,
        0.0
      ],
      "plane_d": -584.18359375,
      "bbox_min": [
        -3345.052001953125,
        -4191.1240234375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3338.30224609375,
        -4184.7890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6890669465065002,
        -0.6829008460044861,
        0.24255552887916565
      ],
      "plane_d": -5427.91357421875,
      "bbox_min": [
        -3345.052001953125,
        -4191.1240234375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3343.540771484375,
        -4189.6796875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3336.0,
        -4213.97900390625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4212.0,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2454.721435546875,
      "bbox_min": [
        -3284.76171875,
        -4239.7685546875,
        1076.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4205.39892578125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9361915588378906,
        -0.0,
        0.35149016976356506
      ],
      "plane_d": 2705.6474609375,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3285.26171875,
        -4194.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4194.208984375,
        1067.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7068547606468201,
        0.7073587775230408,
        0.0
      ],
      "plane_d": 5330.3720703125,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3336.0,
        -4200.72509765625,
        1067.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4235.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1067.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4225.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1067.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3347.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1067.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3337.0,
      "bbox_min": [
        -3337.0,
        -4235.0,
        1062.5
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1062.5,
      "bbox_min": [
        -3337.0,
        -4235.0,
        1062.5
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1062.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4220.0,
      "bbox_min": [
        -3336.0,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4194.208984375,
        1067.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.0,
      "bbox_min": [
        -3315.0,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4220.0,
        1067.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4222.0,
      "bbox_min": [
        -3315.0,
        -4230.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4220.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 2632.26611328125,
      "bbox_min": [
        -3313.757568359375,
        -4222.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3310.0,
        -4220.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1446.0185546875,
      "bbox_min": [
        -3313.757568359375,
        -4222.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3313.53564453125,
        -4221.46435546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3313.0,
      "bbox_min": [
        -3315.0,
        -4230.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3310.0,
        -4222.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3315.0,
      "bbox_min": [
        -3315.0,
        -4230.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3313.0,
        -4222.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1446.0185546875,
      "bbox_min": [
        -3315.0,
        -4230.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3313.0,
        -4222.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4230.0,
      "bbox_min": [
        -3315.0,
        -4230.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3313.0,
        -4230.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827649652957916,
        -0.9238457679748535,
        0.0
      ],
      "plane_d": -2633.52490234375,
      "bbox_min": [
        -3313.0,
        -4225.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3310.0,
        -4222.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238677620887756,
        -0.382711797952652,
        0.0
      ],
      "plane_d": 1443.8165283203125,
      "bbox_min": [
        -3313.0,
        -4225.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3312.121337890625,
        -4222.87890625,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1064.0999755859375,
      "bbox_min": [
        -3315.0,
        -4239.7685546875,
        1064.0999755859375
      ],
      "bbox_max": [
        -3294.300048828125,
        -4220.0,
        1067.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3315.0,
      "bbox_min": [
        -3315.0,
        -4239.7685546875,
        1064.0999755859375
      ],
      "bbox_max": [
        -3294.300048828125,
        -4220.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4222.0,
      "bbox_min": [
        -3315.0,
        -4239.7685546875,
        1064.0999755859375
      ],
      "bbox_max": [
        -3294.300048828125,
        -4220.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 2632.26611328125,
      "bbox_min": [
        -3313.757568359375,
        -4222.0,
        1064.0999755859375
      ],
      "bbox_max": [
        -3310.0,
        -4220.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1446.0185546875,
      "bbox_min": [
        -3313.757568359375,
        -4222.0,
        1064.0999755859375
      ],
      "bbox_max": [
        -3313.53564453125,
        -4221.46435546875,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3313.0,
      "bbox_min": [
        -3315.0,
        -4239.7685546875,
        1064.0999755859375
      ],
      "bbox_max": [
        -3310.0,
        -4222.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1446.0185546875,
      "bbox_min": [
        -3315.0,
        -4225.0,
        1064.0999755859375
      ],
      "bbox_max": [
        -3313.757568359375,
        -4222.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3827649652957916,
        -0.9238457679748535,
        0.0
      ],
      "plane_d": -2633.52490234375,
      "bbox_min": [
        -3313.0,
        -4225.0,
        1064.0999755859375
      ],
      "bbox_max": [
        -3310.0,
        -4222.0,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238677620887756,
        -0.382711797952652,
        0.0
      ],
      "plane_d": 1443.8165283203125,
      "bbox_min": [
        -3313.0,
        -4225.0,
        1064.0999755859375
      ],
      "bbox_max": [
        -3312.121337890625,
        -4222.87890625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -5154.0419921875,
      "bbox_min": [
        -3336.0,
        -4220.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4194.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        -0.0
      ],
      "plane_d": -5144.802734375,
      "bbox_min": [
        -3299.300048828125,
        -4212.74462890625,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4194.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 2614.4453125,
      "bbox_min": [
        -3299.300048828125,
        -4202.74462890625,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4194.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1441.3824462890625,
      "bbox_min": [
        -3299.300048828125,
        -4202.74462890625,
        1052.623779296875
      ],
      "bbox_max": [
        -3297.835693359375,
        -4195.67333984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        -0.0
      ],
      "plane_d": -4655.02490234375,
      "bbox_min": [
        -3299.300048828125,
        -4202.74462890625,
        1052.623779296875
      ],
      "bbox_max": [
        -3297.835693359375,
        -4199.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": -4658.8515625,
      "bbox_min": [
        -3299.300048828125,
        -4212.74462890625,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4204.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1437.555908203125,
      "bbox_min": [
        -3299.300048828125,
        -4209.208984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4204.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 2623.6845703125,
      "bbox_min": [
        -3297.835693359375,
        -4205.67333984375,
        1052.623779296875
      ],
      "bbox_max": [
        -3294.300048828125,
        -4204.208984375,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3335.5,
      "bbox_min": [
        -3336.0,
        -4220.0,
        1055.0
      ],
      "bbox_max": [
        -3335.5,
        -4206.0,
        1065.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4211.0,
      "bbox_min": [
        -3336.0,
        -4220.0,
        1055.0
      ],
      "bbox_max": [
        -3335.5,
        -4206.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4206.0,
      "bbox_min": [
        -3336.0,
        -4206.0,
        1055.0
      ],
      "bbox_max": [
        -3335.5,
        -4206.0,
        1065.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1055.0,
      "bbox_min": [
        -3336.0,
        -4220.0,
        1055.0
      ],
      "bbox_max": [
        -3335.5,
        -4215.0,
        1055.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7086856365203857,
        -0.7055244445800781,
        2.0486642824835144e-05
      ],
      "plane_d": -5330.267578125,
      "bbox_min": [
        -3411.615966796875,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.251708984375,
        -4140.64501953125,
        1067.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7085317969322205,
        -0.7056789398193359,
        0.0
      ],
      "plane_d": -555.638916015625,
      "bbox_min": [
        -3375.85595703125,
        -4200.72509765625,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.251708984375,
        -4140.64501953125,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6541262865066528,
        0.7563854455947876,
        0.0
      ],
      "plane_d": 945.540283203125,
      "bbox_min": [
        -3375.85595703125,
        -4167.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3346.0908203125,
        -4140.64501953125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6562719941139221,
        0.7545244097709656,
        0.0
      ],
      "plane_d": 930.5634765625,
      "bbox_min": [
        -3372.910888671875,
        -4167.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3368.7939453125,
        -4163.4287109375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.5999755859375,
      "bbox_min": [
        -3372.910888671875,
        -4167.0,
        1061.5999755859375
      ],
      "bbox_max": [
        -3368.7939453125,
        -4163.4287109375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34186241030693054,
        0.29567018151283264,
        -0.892025351524353
      ],
      "plane_d": 3329.639892578125,
      "bbox_min": [
        -3375.85595703125,
        -4166.9892578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3346.0908203125,
        -4140.64501953125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.5999755859375,
      "bbox_min": [
        -3375.85595703125,
        -4166.9892578125,
        1061.5999755859375
      ],
      "bbox_max": [
        -3368.7939453125,
        -4160.27880859375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7563573718070984,
        -0.6541587710380554,
        0.0
      ],
      "plane_d": -5241.5400390625,
      "bbox_min": [
        -3354.945068359375,
        -4148.49853515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3346.0908203125,
        -4140.64501953125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3676820397377014,
        -0.31800106167793274,
        -0.8738908767700195
      ],
      "plane_d": -1620.306396484375,
      "bbox_min": [
        -3354.945068359375,
        -4148.49853515625,
        1061.5999755859375
      ],
      "bbox_max": [
        -3346.0908203125,
        -4140.64501953125,
        1065.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068419456481934,
        0.7073715329170227,
        -4.804801574209705e-05
      ],
      "plane_d": 5330.43359375,
      "bbox_min": [
        -3368.5,
        -4200.72509765625,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.251708984375,
        -4169.5,
        1067.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -587.58056640625,
      "bbox_min": [
        -3365.733642578125,
        -4194.77978515625,
        1057.0
      ],
      "bbox_max": [
        -3344.22314453125,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -579.802490234375,
      "bbox_min": [
        -3365.733642578125,
        -4183.50439453125,
        1057.0
      ],
      "bbox_max": [
        -3355.4775390625,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 576.670654296875,
      "bbox_min": [
        -3365.733642578125,
        -4177.74169921875,
        1057.0
      ],
      "bbox_max": [
        -3361.2294921875,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -571.670654296875,
      "bbox_min": [
        -3365.733642578125,
        -4177.74169921875,
        1057.0
      ],
      "bbox_max": [
        -3361.2294921875,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1057.0,
      "bbox_min": [
        -3365.733642578125,
        -4177.74169921875,
        1057.0
      ],
      "bbox_max": [
        -3361.2294921875,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -3365.733642578125,
        -4177.74169921875,
        1064.5
      ],
      "bbox_max": [
        -3361.2294921875,
        -4173.23095703125,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070196866989136,
        0.7071938514709473,
        0.0
      ],
      "plane_d": 585.458984375,
      "bbox_min": [
        -3359.99658203125,
        -4183.50439453125,
        1057.0
      ],
      "bbox_max": [
        -3355.4775390625,
        -4178.978515625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1057.0,
      "bbox_min": [
        -3359.99658203125,
        -4183.50439453125,
        1057.0
      ],
      "bbox_max": [
        -3355.4775390625,
        -4178.978515625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -3359.99658203125,
        -4183.50439453125,
        1064.5
      ],
      "bbox_max": [
        -3355.4775390625,
        -4178.978515625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -595.712646484375,
      "bbox_min": [
        -3354.509033203125,
        -4194.77978515625,
        1057.0
      ],
      "bbox_max": [
        -3344.22314453125,
        -4184.4765625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 592.58056640625,
      "bbox_min": [
        -3354.509033203125,
        -4189.0166015625,
        1057.0
      ],
      "bbox_max": [
        -3349.975341796875,
        -4184.4765625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1057.0,
      "bbox_min": [
        -3354.509033203125,
        -4189.0166015625,
        1057.0
      ],
      "bbox_max": [
        -3349.975341796875,
        -4184.4765625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -3354.509033203125,
        -4189.0166015625,
        1064.5
      ],
      "bbox_max": [
        -3349.975341796875,
        -4184.4765625,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 600.712646484375,
      "bbox_min": [
        -3348.771728515625,
        -4194.77978515625,
        1057.0
      ],
      "bbox_max": [
        -3344.22314453125,
        -4190.224609375,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.5,
      "bbox_min": [
        -3348.771728515625,
        -4194.77978515625,
        1057.0
      ],
      "bbox_max": [
        -3344.22314453125,
        -4190.224609375,
        1064.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1057.0,
      "bbox_min": [
        -3348.771728515625,
        -4194.77978515625,
        1057.0
      ],
      "bbox_max": [
        -3344.22314453125,
        -4190.224609375,
        1057.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6560693383216858,
        -0.7547007203102112,
        0.0
      ],
      "plane_d": -946.152099609375,
      "bbox_min": [
        -3411.615966796875,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3359.7470703125,
        -4162.931640625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.754712700843811,
        -0.6560553908348083,
        0.0
      ],
      "plane_d": -5325.5615234375,
      "bbox_min": [
        -3411.615966796875,
        -4208.01025390625,
        1052.623779296875
      ],
      "bbox_max": [
        -3372.89990234375,
        -4162.931640625,
        1067.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7547022700309753,
        0.6560674905776978,
        0.0
      ],
      "plane_d": 5305.576171875,
      "bbox_min": [
        -3403.20263671875,
        -4194.888671875,
        1052.623779296875
      ],
      "bbox_max": [
        -3372.89990234375,
        -4163.84912109375,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.656043291091919,
        0.7547232508659363,
        0.0
      ],
      "plane_d": 936.3349609375,
      "bbox_min": [
        -3403.20263671875,
        -4193.90234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3389.94287109375,
        -4187.33056640625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547353506088257,
        0.6560294032096863,
        0.0
      ],
      "plane_d": 5315.529296875,
      "bbox_min": [
        -3403.20263671875,
        -4193.90234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3397.490234375,
        -4187.33056640625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5331.51416015625,
      "bbox_min": [
        -3376.050537109375,
        -4167.0,
        1061.5999755859375
      ],
      "bbox_max": [
        -3372.89990234375,
        -4163.84912109375,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1061.5999755859375,
      "bbox_min": [
        -3375.86328125,
        -4167.0,
        1061.5999755859375
      ],
      "bbox_max": [
        -3372.89990234375,
        -4164.0302734375,
        1061.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6560397148132324,
        -0.7547264695167542,
        0.0
      ],
      "plane_d": -936.360595703125,
      "bbox_min": [
        -3405.037109375,
        -4200.46240234375,
        1062.5999755859375
      ],
      "bbox_max": [
        -3372.89990234375,
        -4162.931640625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7547096610069275,
        0.6560589075088501,
        0.0
      ],
      "plane_d": 5315.5654296875,
      "bbox_min": [
        -3404.052001953125,
        -4193.90234375,
        1062.5999755859375
      ],
      "bbox_max": [
        -3372.89990234375,
        -4162.931640625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -5331.51416015625,
      "bbox_min": [
        -3376.968017578125,
        -4167.0,
        1062.5999755859375
      ],
      "bbox_max": [
        -3372.89990234375,
        -4162.931640625,
        1067.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1062.5999755859375,
      "bbox_min": [
        -3380.960205078125,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3359.7470703125,
        -4204.5400390625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 592.35888671875,
      "bbox_min": [
        -3380.960205078125,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3359.7470703125,
        -4204.5400390625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -602.358642578125,
      "bbox_min": [
        -3380.960205078125,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3359.7470703125,
        -4204.5400390625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070945501327515,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 5353.76904296875,
      "bbox_min": [
        -3380.960205078125,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3359.7470703125,
        -4204.5400390625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189880371094,
        0.0
      ],
      "plane_d": -5373.7685546875,
      "bbox_min": [
        -3380.960205078125,
        -4225.7529296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3373.88916015625,
        -4218.68212890625,
        1062.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6688962578773499,
        0.6624125838279724,
        0.3373238742351532
      ],
      "plane_d": 4618.2919921875,
      "bbox_min": [
        -3350.587890625,
        -4150.279296875,
        1053.0523681640625
      ],
      "bbox_max": [
        -3335.2080078125,
        -4135.7763671875,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6713940501213074,
        0.6649112105369568,
        0.32729673385620117
      ],
      "plane_d": 4647.7470703125,
      "bbox_min": [
        -3350.587890625,
        -4150.279296875,
        1053.0523681640625
      ],
      "bbox_max": [
        -3335.2080078125,
        -4135.7763671875,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3350.587890625,
        -4144.32568359375,
        1070.0885009765625
      ],
      "bbox_max": [
        -3339.879638671875,
        -4136.91650390625,
        1076.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6691474318504333,
        0.6691474318504333,
        0.32323914766311646
      ],
      "plane_d": 4662.142578125,
      "bbox_min": [
        -3342.244384765625,
        -4144.32568359375,
        1070.0885009765625
      ],
      "bbox_max": [
        -3339.879638671875,
        -4142.5673828125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6665334701538086,
        0.6665472984313965,
        0.3338381052017212
      ],
      "plane_d": 4631.18603515625,
      "bbox_min": [
        -3342.22705078125,
        -4137.9462890625,
        1053.0523681640625
      ],
      "bbox_max": [
        -3337.58447265625,
        -4135.7763671875,
        1058.5216064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2643769681453705,
        0.26181721687316895,
        -0.9282006621360779
      ],
      "plane_d": 2963.95458984375,
      "bbox_min": [
        -3350.560302734375,
        -4205.49609375,
        1072.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4131.3486328125,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1076.5999755859375,
      "bbox_min": [
        -3350.560302734375,
        -4205.49609375,
        1072.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4131.3486328125,
        1080.5999755859375
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2454.721435546875,
      "bbox_min": [
        -3285.76171875,
        -4205.49609375,
        1076.5999755859375
      ],
      "bbox_max": [
        -3282.76171875,
        -4190.2412109375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3285.76171875,
      "bbox_min": [
        -3285.76171875,
        -4204.48681640625,
        1076.5999755859375
      ],
      "bbox_max": [
        -3285.76171875,
        -4190.2412109375,
        1080.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26335620880126953,
        0.26104477047920227,
        -0.9287083148956299
      ],
      "plane_d": 2957.899169921875,
      "bbox_min": [
        -3330.56494140625,
        -4193.140625,
        1072.5999755859375
      ],
      "bbox_max": [
        -3285.73291015625,
        -4145.029296875,
        1075.4114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 2218.78515625,
      "bbox_min": [
        -3292.76171875,
        -4193.140625,
        1072.5999755859375
      ],
      "bbox_max": [
        -3285.73291015625,
        -4190.2412109375,
        1075.4114990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4232.6044921875,
        1062.68994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4235.2646484375,
        1058.951904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5928899049758911,
        -0.5947738885879517,
        0.5428864359855652
      ],
      "plane_d": -1097.1802978515625,
      "bbox_min": [
        -3291.98681640625,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4041.88818359375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.59621661901474,
        -0.5943341851234436,
        0.5397154092788696
      ],
      "plane_d": -1081.202392578125,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5952767729759216,
        -0.5952798128128052,
        0.5397107005119324
      ],
      "plane_d": -1088.1044921875,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7059842348098755,
        0.7082275748252869,
        0.0
      ],
      "plane_d": 613.07861328125,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5260.3076171875,
      "bbox_min": [
        -3291.98681640625,
        -4156.353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4042.05517578125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070973515510559,
        0.7071163058280945,
        0.0
      ],
      "plane_d": 5192.8408203125,
      "bbox_min": [
        -3244.19921875,
        -4108.6416015625,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4042.05517578125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3234.283935546875,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4042.05517578125,
        1072.5887451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5111.3583984375,
      "bbox_min": [
        -3186.496337890625,
        -4050.955078125,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.596435546875,
        -4042.05517578125,
        1072.2554931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5178.8330078125,
      "bbox_min": [
        -3234.2998046875,
        -4089.69140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3186.496337890625,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5111.3583984375,
      "bbox_min": [
        -3186.663330078125,
        -4042.05517578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3186.496337890625,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5938324332237244,
        -0.5938324332237244,
        0.5428869724273682
      ],
      "plane_d": -1090.173828125,
      "bbox_min": [
        -3234.2998046875,
        -4098.7421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5111.3583984375,
      "bbox_min": [
        -3186.663330078125,
        -4051.0302734375,
        1052.623779296875
      ],
      "bbox_max": [
        -3177.521240234375,
        -4041.88818359375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3169.999755859375,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3169.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1071.313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3169.999755859375,
        -4179.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4179.7685546875,
        1071.313232421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3216.391357421875,
        -4179.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3222.63623046875,
        -4239.7685546875,
        1063.970703125
      ],
      "bbox_max": [
        -3216.391357421875,
        -4179.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3222.63623046875,
        -4179.7685546875,
        1063.9708251953125
      ],
      "bbox_max": [
        -3216.391357421875,
        -4179.7685546875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3222.63623046875,
        -4179.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3219.999755859375,
        -4179.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3180.824951171875,
        -4239.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3170.936279296875,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3180.824951171875,
        -4179.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3170.936279296875,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3219.063232421875,
        -4239.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": -3242.712158203125,
      "bbox_min": [
        -3219.063232421875,
        -4239.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3219.063232421875,
        -4179.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -3209.174560546875,
        -4179.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -5085.8330078125,
      "bbox_min": [
        -3421.765380859375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3942.823486328125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 5082.8330078125,
      "bbox_min": [
        -3191.951416015625,
        -4060.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3942.823486328125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4060.0,
      "bbox_min": [
        -3132.453369140625,
        -4060.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3128.210693359375,
        -4060.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4057.0,
      "bbox_min": [
        -3172.531982421875,
        -4060.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -3942.823486328125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4060.0,
      "bbox_min": [
        -3128.210693359375,
        -4060.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3086.468505859375,
        -4060.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3109.968505859375,
      "bbox_min": [
        -3172.531982421875,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071101069450378,
        -0.7071035504341125,
        0.0
      ],
      "plane_d": -5057.2236328125,
      "bbox_min": [
        -3172.531982421875,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3944.245361328125,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5055.4599609375,
      "bbox_min": [
        -3169.5,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3944.245361328125,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3133.49755859375,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3130.999267578125,
        -4018.5,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3112.968505859375,
      "bbox_min": [
        -3169.5,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3944.245361328125,
        1086.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3980.0,
      "bbox_min": [
        -3112.968505859375,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3112.968505859375,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3109.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3130.999267578125,
        -4018.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3555326759815216,
        0.0,
        -0.9346638321876526
      ],
      "plane_d": -94.9755859375,
      "bbox_min": [
        -3119.630615234375,
        -3947.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3113.2578125,
        -3944.245361328125,
        1085.0479736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3121.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 610.5869140625,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3121.5,
        -3985.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4002.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3121.5,
        -4002.5,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3990.0,
      "bbox_min": [
        -3121.5,
        -3990.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -3121.5,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        -3169.5,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3955.804931640625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3150.0,
      "bbox_min": [
        -3169.5,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3975.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3150.0,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3975.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3985.0,
      "bbox_min": [
        -3150.0,
        -3985.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3985.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3169.5,
      "bbox_min": [
        -3169.5,
        -3980.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3169.5,
        -3976.84326171875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3146.0,
      "bbox_min": [
        -3149.70458984375,
        -3975.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3146.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3146.0,
        -3960.0,
        1086.0
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3144.0,
        -3960.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.9443359375,
      "bbox_min": [
        -3211.91748046875,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3178.08203125,
        -4179.7685546875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3210.25927734375,
        -4239.7685546875,
        1084.9443359375
      ],
      "bbox_max": [
        -3179.740234375,
        -4179.7685546875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": -1945.72900390625,
      "bbox_min": [
        -3211.91748046875,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3178.08203125,
        -4179.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3211.91748046875,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3207.499755859375,
        -4179.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3300.800048828125,
      "bbox_min": [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3297.279052734375,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3300.800048828125,
        -4195.38037109375,
        1082.623779296875
      ],
      "bbox_max": [
        -3297.279052734375,
        -4191.3876953125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6655337810516357,
        0.6799509525299072,
        0.3077850043773651
      ],
      "plane_d": 306.72271728515625,
      "bbox_min": [
        -3370.07177734375,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3300.800048828125,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5865098237991333,
        -0.8099421262741089,
        0.0
      ],
      "plane_d": -1454.8795166015625,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3300.800048828125,
        -4181.48876953125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3326.19921875,
        -4201.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3304.650390625,
        -4181.48876953125,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117648720741272,
        -0.70241779088974,
        -0.00013719097478315234
      ],
      "plane_d": -5296.8720703125,
      "bbox_min": [
        -3326.19921875,
        -4201.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3306.49267578125,
        -4183.97216796875,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7051839232444763,
        0.7090244889259338,
        0.0
      ],
      "plane_d": 5321.234375,
      "bbox_min": [
        -3326.19921875,
        -4201.5,
        1082.623779296875
      ],
      "bbox_max": [
        -3321.5,
        -4196.826171875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3347.0,
        -4239.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3300.800048828125,
        -4188.53759765625,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4225.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4235.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.0,
        -4225.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3347.0,
      "bbox_min": [
        -3347.0,
        -4235.0,
        1082.623779296875
      ],
      "bbox_max": [
        -3347.0,
        -4225.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117648720741272,
        -0.70241779088974,
        -0.00013719097478315234
      ],
      "plane_d": -5296.8720703125,
      "bbox_min": [
        -3306.4931640625,
        -4196.40185546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3300.800048828125,
        -4188.53759765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3304.418212890625,
        -4192.81494140625,
        1082.623779296875
      ],
      "bbox_max": [
        -3300.800048828125,
        -4188.53759765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6345945000648499,
        0.7338024973869324,
        0.24253620207309723
      ],
      "plane_d": 684.877197265625,
      "bbox_min": [
        -3348.82568359375,
        -4220.7724609375,
        1082.623779296875
      ],
      "bbox_max": [
        -3310.33837890625,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3348.82568359375,
        -4220.7724609375,
        1082.623779296875
      ],
      "bbox_max": [
        -3310.33837890625,
        -4166.69384765625,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3348.82568359375,
        -4220.7724609375,
        1082.623779296875
      ],
      "bbox_max": [
        -3312.1630859375,
        -4172.5888671875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117072939872742,
        -0.7024762034416199,
        0.0
      ],
      "plane_d": -5297.07421875,
      "bbox_min": [
        -3326.662841796875,
        -4197.7333984375,
        1082.623779296875
      ],
      "bbox_max": [
        -3312.1630859375,
        -4183.1416015625,
        1086.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6890669465065002,
        -0.6829008460044861,
        0.24255552887916565
      ],
      "plane_d": -5427.91357421875,
      "bbox_min": [
        -3347.4892578125,
        -4189.6796875,
        1082.623779296875
      ],
      "bbox_max": [
        -3343.163330078125,
        -4186.07275390625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117072939872742,
        -0.7024762034416199,
        0.0
      ],
      "plane_d": -5297.07421875,
      "bbox_min": [
        -3343.9140625,
        -4201.802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3313.168701171875,
        -4172.5888671875,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7090442180633545,
        0.7051639556884766,
        -4.60024921267177e-06
      ],
      "plane_d": 598.4434814453125,
      "bbox_min": [
        -3343.9140625,
        -4201.802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3325.938720703125,
        -4184.7890625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6889576315879822,
        -0.6830261945724487,
        0.24251310527324677
      ],
      "plane_d": -5428.02783203125,
      "bbox_min": [
        -3333.346435546875,
        -4201.802734375,
        1082.623779296875
      ],
      "bbox_max": [
        -3325.938720703125,
        -4195.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7051839232444763,
        0.7090244889259338,
        0.0
      ],
      "plane_d": 5321.234375,
      "bbox_min": [
        -3328.035400390625,
        -4197.0849609375,
        1082.623779296875
      ],
      "bbox_max": [
        -3325.938720703125,
        -4195.0,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7090144157409668,
        -0.7051939964294434,
        0.0
      ],
      "plane_d": -584.18359375,
      "bbox_min": [
        -3343.9140625,
        -4190.05615234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3338.30224609375,
        -4184.7890625,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6890669465065002,
        -0.6829008460044861,
        0.24255552887916565
      ],
      "plane_d": -5427.91357421875,
      "bbox_min": [
        -3343.9140625,
        -4190.05615234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3342.83984375,
        -4189.02490234375,
        1086.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1102.623779296875,
      "bbox_min": [
        -3438.244384765625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3434.6865234375,
        -4211.79345703125,
        1097.302490234375
      ],
      "bbox_max": [
        -3423.474609375,
        -4200.58154296875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.5999755859375,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4179.7685546875,
      "bbox_min": [
        -3209.076171875,
        -4179.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3180.92333984375,
        -4179.7685546875,
        1087.26513671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9697036743164062,
        -0.0,
        0.24428436160087585
      ],
      "plane_d": 2932.915771484375,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3298.28076171875,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3300.800048828125,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3298.28076171875,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6919705271720886,
        0.6794916391372681,
        0.24386051297187805
      ],
      "plane_d": 4868.060546875,
      "bbox_min": [
        -3300.800048828125,
        -4196.40380859375,
        1086.5999755859375
      ],
      "bbox_max": [
        -3298.28076171875,
        -4192.81494140625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6965505480766296,
        0.67300945520401,
        0.24874787032604218
      ],
      "plane_d": 237.70416259765625,
      "bbox_min": [
        -3368.23291015625,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3300.800048828125,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117648720741272,
        -0.70241779088974,
        -0.00013719097478315234
      ],
      "plane_d": -5296.8720703125,
      "bbox_min": [
        -3336.0,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3300.800048828125,
        -4182.02978515625,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5865098237991333,
        -0.8099421262741089,
        0.0
      ],
      "plane_d": -1454.8795166015625,
      "bbox_min": [
        -3336.0,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3321.5,
        -4197.0849609375,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7051839232444763,
        0.7090244889259338,
        0.0
      ],
      "plane_d": 5321.234375,
      "bbox_min": [
        -3325.938720703125,
        -4201.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3321.5,
        -4197.0849609375,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3336.0,
      "bbox_min": [
        -3336.0,
        -4239.7685546875,
        1086.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4212.0,
        1096.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6916755437850952,
        0.6802629828453064,
        0.24254301190376282
      ],
      "plane_d": 4871.7421875,
      "bbox_min": [
        -3346.0341796875,
        -4201.8291015625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3311.339111328125,
        -4168.0556640625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.656984269618988,
        -0.753904402256012,
        0.0
      ],
      "plane_d": -961.71875,
      "bbox_min": [
        -3346.0341796875,
        -4201.8291015625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3311.365234375,
        -4172.5888671875,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6890669465065002,
        -0.6829008460044861,
        0.24255552887916565
      ],
      "plane_d": -5427.91357421875,
      "bbox_min": [
        -3346.0341796875,
        -4189.02490234375,
        1086.5999755859375
      ],
      "bbox_max": [
        -3341.27490234375,
        -4186.12890625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7117648720741272,
        -0.70241779088974,
        -0.00013719097478315234
      ],
      "plane_d": -5296.8720703125,
      "bbox_min": [
        -3343.163330078125,
        -4201.8291015625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3311.365234375,
        -4172.5888671875,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.689002513885498,
        -0.6829832196235657,
        0.2425064891576767
      ],
      "plane_d": -5427.9892578125,
      "bbox_min": [
        -3343.163330078125,
        -4201.8291015625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3324.11767578125,
        -4184.7890625,
        1096.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7090144157409668,
        -0.7051939964294434,
        0.0
      ],
      "plane_d": -584.18359375,
      "bbox_min": [
        -3342.83984375,
        -4189.3515625,
        1086.5999755859375
      ],
      "bbox_max": [
        -3338.30224609375,
        -4184.7890625,
        1090.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3109.968505859375,
      "bbox_min": [
        -3174.404541015625,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1096.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071101069450378,
        -0.7071035504341125,
        0.0
      ],
      "plane_d": -5057.2236328125,
      "bbox_min": [
        -3174.404541015625,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.0,
      "bbox_min": [
        -3160.0,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3130.999267578125,
        -3989.5,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3133.49755859375,
        -4018.5,
        1092.0
      ],
      "bbox_max": [
        -3130.999267578125,
        -4018.5,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3160.0,
      "bbox_min": [
        -3160.0,
        -3991.997314453125,
        1086.5999755859375
      ],
      "bbox_max": [
        -3160.0,
        -3989.5,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3112.968505859375,
      "bbox_min": [
        -3169.5,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3112.968505859375,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3112.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3970.0,
      "bbox_min": [
        -3112.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3970.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3980.0,
      "bbox_min": [
        -3112.968505859375,
        -3980.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3980.0,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3133.5,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -4016.0,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.0,
      "bbox_min": [
        -3133.5,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3117.0,
        -4016.0,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3117.0,
      "bbox_min": [
        -3117.0,
        -4018.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3117.0,
        -4016.0,
        1092.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3950.0,
      "bbox_min": [
        -3169.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3950.0,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3140.0,
      "bbox_min": [
        -3169.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3955.804931640625,
        1096.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3975.0,
      "bbox_min": [
        -3150.0,
        -3985.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3985.0,
      "bbox_min": [
        -3150.0,
        -3985.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3140.0,
        -3985.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3960.0,
      "bbox_min": [
        -3149.70458984375,
        -3975.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3140.0,
        -3960.0,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3144.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1090.0
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1094.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.0,
      "bbox_min": [
        -3146.0,
        -3975.0,
        1094.0
      ],
      "bbox_max": [
        -3144.0,
        -3960.0,
        1094.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3169.5,
      "bbox_min": [
        -3169.5,
        -3980.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3169.5,
        -3973.3515625,
        1096.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.4000244140625,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3121.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3126.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3121.5,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 610.5869140625,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3121.5,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4002.5,
      "bbox_min": [
        -3126.5,
        -4002.5,
        1086.5999755859375
      ],
      "bbox_max": [
        -3121.5,
        -4002.5,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3990.0,
      "bbox_min": [
        -3121.5,
        -3990.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3985.0,
      "bbox_min": [
        -3121.5,
        -3985.0,
        1086.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -3985.0,
        1087.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7191548943519592,
        0.6948498487472534,
        0.0
      ],
      "plane_d": 527.047119140625,
      "bbox_min": [
        -3363.6083984375,
        -4239.7685546875,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3300.800048828125,
      "bbox_min": [
        -3311.339111328125,
        -4239.7685546875,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3977.256591796875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7135111689567566,
        0.7006438374519348,
        0.0
      ],
      "plane_d": 5295.34228515625,
      "bbox_min": [
        -3311.339111328125,
        -4196.40380859375,
        1096.5999755859375
      ],
      "bbox_max": [
        -3300.800048828125,
        -4185.6708984375,
        1100.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3109.968505859375,
      "bbox_min": [
        -3141.7978515625,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3977.256591796875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -3112.968505859375,
      "bbox_min": [
        -3141.7978515625,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3980.361572265625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3112.968505859375,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -4018.5,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4018.5,
      "bbox_min": [
        -3141.7978515625,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -4008.92919921875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4016.0,
      "bbox_min": [
        -3141.7978515625,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3112.968505859375,
        -4008.92919921875,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071101069450378,
        -0.7071035504341125,
        0.0
      ],
      "plane_d": -5057.2236328125,
      "bbox_min": [
        -3135.99755859375,
        -4018.5,
        1096.5999755859375
      ],
      "bbox_max": [
        -3133.49755859375,
        -4016.0,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071101069450378,
        -0.7071035504341125,
        0.0
      ],
      "plane_d": -5057.2236328125,
      "bbox_min": [
        -3141.7978515625,
        -4016.0,
        1096.5999755859375
      ],
      "bbox_max": [
        -3135.99755859375,
        -4010.199462890625,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5055.4599609375,
      "bbox_min": [
        -3342.374755859375,
        -4201.8291015625,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7102034687995911,
        -0.703996479511261,
        -0.0
      ],
      "plane_d": -5320.884765625,
      "bbox_min": [
        -3342.374755859375,
        -4201.8291015625,
        1096.5999755859375
      ],
      "bbox_max": [
        -3311.339111328125,
        -4171.48046875,
        1100.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7135111689567566,
        0.7006438374519348,
        0.0
      ],
      "plane_d": 5295.34228515625,
      "bbox_min": [
        -3325.27392578125,
        -4185.6708984375,
        1096.5999755859375
      ],
      "bbox_max": [
        -3311.339111328125,
        -4171.48046875,
        1100.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3109.968505859375,
      "bbox_min": [
        -3169.5,
        -3980.361572265625,
        1096.5999755859375
      ],
      "bbox_max": [
        -3109.968505859375,
        -3942.823486328125,
        1102.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3438.244384765625,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3376.999755859375,
        -4188.44482421875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071084976196289,
        0.7071051597595215,
        0.0
      ],
      "plane_d": 5398.94921875,
      "bbox_min": [
        -3438.244384765625,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3395.499755859375,
        -4197.02392578125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3746.760498046875,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1102.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1195.5255126953125
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067084789276123,
        0.9135580062866211,
        0.0
      ],
      "plane_d": 2985.219970703125,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3744.02880859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3599.999755859375,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4719.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3339.772216796875,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 13.907958984375,
      "bbox_min": [
        -3244.087890625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4484086036682129,
        0.8938286900520325,
        0.0
      ],
      "plane_d": 2783.90478515625,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": -300.9292297363281,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 2257.107666015625,
      "bbox_min": [
        -3145.921875,
        -4710.5654296875,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3244.087890625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3170.900634765625,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3231.590087890625,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138801693916321,
        0.4059842526912689,
        0.0
      ],
      "plane_d": -1039.8768310546875,
      "bbox_min": [
        -3244.087890625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3240.07275390625,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3600.0,
        -5045.98291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.541015625,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4947.19970703125,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4854.802734375,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4829.7685546875,
        1202.759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3335.999755859375,
        -4850.7685546875,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3332.493896484375,
        -4850.7685546875,
        1102.6241455078125
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9056028723716736,
        0.4241252839565277,
        0.001009006635285914
      ],
      "plane_d": -905.1506958007812,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3308.169189453125,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3270.07763671875,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2929.999755859375,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9060541987419128,
        0.4231615662574768,
        -3.4665109893694535e-08
      ],
      "plane_d": -910.1381225585938,
      "bbox_min": [
        -3270.07763671875,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9055988192558289,
        0.42413514852523804,
        0.0
      ],
      "plane_d": -903.927734375,
      "bbox_min": [
        -3246.87841796875,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3229.37255859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3222.96435546875,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2970.626953125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3222.96435546875,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9033738970756531,
        0.42883458733558655,
        -0.004077742341905832
      ],
      "plane_d": -869.732666015625,
      "bbox_min": [
        -3246.87841796875,
        -4801.26220703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.96435546875,
        -4750.25830078125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3223.03857421875,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.96435546875,
        -4750.25830078125,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3270.07763671875,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3252.545654296875,
        -4813.37158203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.16366951167583466,
        0.98651522397995
      ],
      "plane_d": -289.88616943359375,
      "bbox_min": [
        -3270.06005859375,
        -4850.7685546875,
        1098.61474609375
      ],
      "bbox_max": [
        -3269.999755859375,
        -4850.7138671875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138801693916321,
        0.4059842526912689,
        0.0
      ],
      "plane_d": -1039.8768310546875,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3223.016357421875,
        -4740.7734375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4932.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3223.016357421875,
        -4740.7734375,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.76904296875,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3240.564208984375,
        -4786.7001953125,
        1098.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3246.999755859375,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4786.7001953125,
      "bbox_min": [
        -3253.999755859375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3253.0908203125,
      "bbox_min": [
        -3253.0908203125,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3253.0908203125,
        -4786.7001953125,
        1093.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1425086259841919,
        0.06312164664268494,
        0.9877788424491882
      ],
      "plane_d": -1244.798095703125,
      "bbox_min": [
        -3292.78662109375,
        -4850.7685546875,
        1094.9818115234375
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.76904296875,
        -4787.7001953125,
        1094.9818115234375
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.16366951167583466,
        0.98651522397995
      ],
      "plane_d": -289.88616943359375,
      "bbox_min": [
        -3292.78662109375,
        -4850.7685546875,
        1095.123779296875
      ],
      "bbox_max": [
        -3270.034423828125,
        -4829.67236328125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3264.76904296875,
        -4787.7001953125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9143241047859192,
        0.4049834907054901,
        0.0
      ],
      "plane_d": -1046.1676025390625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3264.76904296875,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1425086259841919,
        0.06312164664268494,
        0.9877788424491882
      ],
      "plane_d": -1244.798095703125,
      "bbox_min": [
        -3283.414794921875,
        -4829.67236328125,
        1082.623779296875
      ],
      "bbox_max": [
        -3264.76904296875,
        -4787.7001953125,
        1095.1317138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.823974609375,
        -4787.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3264.76904296875,
        -4787.7001953125,
        1095.1317138671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10610295832157135,
        0.9943552017211914,
        0.0
      ],
      "plane_d": 5150.78955078125,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.01479284092783928,
        0.13863268494606018,
        0.9902334809303284
      ],
      "plane_d": -366.30670166015625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1095.123779296875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4825.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.16366951167583466,
        0.98651522397995
      ],
      "plane_d": -289.88616943359375,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1095.123779296875
      ],
      "bbox_max": [
        -3283.414794921875,
        -4829.67236328125,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.547119140625,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838623046875,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838623046875,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2970.626953125,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3319.999755859375,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4854.5673828125,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4829.7685546875,
        1201.8182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.838623046875,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8356147408485413,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": -1788.7464599609375,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3600.0,
        -4916.06201171875,
        1201.8182373046875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4746.9443359375,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4863.9697265625,
        1201.8182373046875
      ],
      "bbox_max": [
        -3566.1171875,
        -4854.5673828125,
        1239.427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3302.565185546875,
        -4912.5498046875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3292.71533203125,
        -4855.56982421875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3600.0,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3600.0,
        -4879.7685546875,
        1238.15380859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4863.6513671875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4418.13818359375,
      "bbox_min": [
        -3699.999755859375,
        -4879.7685546875,
        1198.05712890625
      ],
      "bbox_max": [
        -3600.0,
        -4853.626953125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.5699014258862007e-06
      ],
      "plane_d": -3128.597412109375,
      "bbox_min": [
        -3170.00048828125,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923880934715271,
        0.38268008828163147,
        0.0
      ],
      "plane_d": -1233.537841796875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268569111824036,
        0.9238786101341248,
        0.0
      ],
      "plane_d": 2758.4775390625,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6304340362548828,
        0.0,
        0.7762427926063538
      ],
      "plane_d": -2827.50341796875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -4.763341712532565e-05
      ],
      "plane_d": -3169.94970703125,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3170.00048828125,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -3155.499755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3155.499755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.682324230670929,
        0.0,
        0.7310497760772705
      ],
      "plane_d": -2922.59423828125,
      "bbox_min": [
        -3155.499755859375,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3151.214111328125,
        -4409.7685546875,
        1056.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.682324230670929,
        0.0,
        0.7310497760772705
      ],
      "plane_d": -2922.59423828125,
      "bbox_min": [
        -3151.214111328125,
        -4419.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3140.499755859375,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3155.499755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4369.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4379.7685546875,
      "bbox_min": [
        -3151.214111328125,
        -4389.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3222.63623046875,
      "bbox_min": [
        -3384.574951171875,
        -4371.52392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3167.36328125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3219.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3169.999755859375,
      "bbox_min": [
        -3169.999755859375,
        -4309.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3169.999755859375,
        -4249.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1087.26513671875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": 1956.310546875,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3167.36328125,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8136186599731445,
        0.0,
        0.5813989043235779
      ],
      "plane_d": -3242.712158203125,
      "bbox_min": [
        -3222.63623046875,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3169.999755859375,
        -4249.7685546875,
        1087.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1084.9443359375,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3169.999755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": -1945.72900390625,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3169.999755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8108856678009033,
        0.0,
        -0.5852046608924866
      ],
      "plane_d": 3235.830078125,
      "bbox_min": [
        -3219.999755859375,
        -4309.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -3207.499755859375,
        -4249.7685546875,
        1084.9443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4647.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4595.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4648.36865234375,
      "bbox_min": [
        -3554.599853515625,
        -4650.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2521.3623046875,
      "bbox_min": [
        -3554.599853515625,
        -4650.36865234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4648.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4563.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4404.36865234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3334.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4563.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2750813663005829,
        0.35142311453819275,
        0.894892156124115
      ],
      "plane_d": -215.431884765625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27700290083885193,
        0.3484245240688324,
        0.8954717516899109
      ],
      "plane_d": -237.17449951171875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270551264286041,
        0.3094017207622528,
        0.892919659614563
      ],
      "plane_d": -576.7142333984375,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3714085817337036,
        1.1238243132538628e-05,
        0.9284694790840149
      ],
      "plane_d": -2031.978759765625,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.42334893345832825,
        0.0,
        0.9059666991233826
      ],
      "plane_d": 407.424560546875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4839.27294921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4282.8349609375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4839.27294921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4556.68505859375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3981.11767578125,
        -4839.27294921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4717.58447265625,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3963.99951171875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4828.22119140625,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3758.24658203125,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3488.941650390625,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.16748046875,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2032.00439453125,
      "bbox_min": [
        -2978.129638671875,
        -4910.2978515625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2297457456588745,
        0.4098278880119324,
        0.8827558755874634
      ],
      "plane_d": 157.9915771484375,
      "bbox_min": [
        -2214.77978515625,
        -4508.150390625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4379.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2962.83203125,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: eledor2a",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor2a",
      "offset": 52170,
      "centroid": [
        -3336.5,
        -4228.333333333333,
        1081.5999755859375
      ],
      "bbox_min": [
        -3337.0,
        -4230.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1086.5999755859375
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 5.0,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3337.0,
          -4225.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4225.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4225.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4225.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1076.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1076.5999755859375
        ]
      ],
      "plane_distance": -4230.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: eledor2b",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor2b",
      "offset": 53533,
      "centroid": [
        -3336.5,
        -4232.5,
        1081.5999755859375
      ],
      "bbox_min": [
        -3337.0,
        -4235.0,
        1076.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4230.0,
        1086.5999755859375
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 5.0,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3337.0,
          -4235.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4235.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4235.0,
          1076.5999755859375
        ],
        [
          -3336.0,
          -4235.0,
          1086.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1076.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1086.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1076.5999755859375
        ]
      ],
      "plane_distance": 4230.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: eledor1a",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor1a",
      "offset": 54800,
      "centroid": [
        -3336.5,
        -4228.333333333333,
        1057.5499877929688
      ],
      "bbox_min": [
        -3337.0,
        -4230.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4225.0,
        1062.5
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 5.0,
        "height_z": 9.9000244140625,
        "door_width": 5.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3337.0,
          -4225.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4225.0,
          1062.5
        ],
        [
          -3336.0,
          -4225.0,
          1062.5
        ],
        [
          -3336.0,
          -4225.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1062.5
        ],
        [
          -3337.0,
          -4230.0,
          1062.5
        ],
        [
          -3336.0,
          -4230.0,
          1062.5
        ],
        [
          -3336.0,
          -4230.0,
          1062.5
        ],
        [
          -3336.0,
          -4230.0,
          1052.5999755859375
        ],
        [
          -3336.0,
          -4230.0,
          1052.5999755859375
        ]
      ],
      "plane_distance": -4230.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: eledor1b",
      "entity_class": "CSlidingDoor",
      "piece_name": "eledor1b",
      "offset": 56015,
      "centroid": [
        -3336.5,
        -4232.5,
        1057.5499877929688
      ],
      "bbox_min": [
        -3337.0,
        -4235.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3336.0,
        -4230.0,
        1062.5
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 5.0,
        "height_z": 9.9000244140625,
        "door_width": 5.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3337.0,
          -4235.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4235.0,
          1062.5
        ],
        [
          -3336.0,
          -4235.0,
          1052.5999755859375
        ],
        [
          -3336.0,
          -4235.0,
          1062.5
        ],
        [
          -3337.0,
          -4230.0,
          1052.5999755859375
        ],
        [
          -3337.0,
          -4230.0,
          1062.5
        ],
        [
          -3336.0,
          -4230.0,
          1062.5
        ],
        [
          -3336.0,
          -4230.0,
          1052.5999755859375
        ]
      ],
      "plane_distance": 4230.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: nmvplat1",
      "entity_class": "CSlidingDoor",
      "piece_name": "nmvplat1",
      "offset": 59885,
      "centroid": [
        -3129.5,
        -3897.5,
        1076.0
      ],
      "bbox_min": [
        -3150.0,
        -3908.0,
        1075.5
      ],
      "bbox_max": [
        -3109.0,
        -3887.0,
        1076.5
      ],
      "dimensions_source": {
        "span_x": 41.0,
        "span_y": 21.0,
        "height_z": 1.0,
        "door_width": 41.0,
        "door_depth": 21.0,
        "leaf_depth": 20.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -3109.0,
          -3887.0,
          1076.5
        ],
        [
          -3109.0,
          -3908.0,
          1076.5
        ],
        [
          -3150.0,
          -3887.0,
          1075.5
        ],
        [
          -3150.0,
          -3887.0,
          1076.5
        ],
        [
          -3150.0,
          -3908.0,
          1076.5
        ],
        [
          -3150.0,
          -3908.0,
          1075.5
        ],
        [
          -3109.0,
          -3908.0,
          1075.5
        ],
        [
          -3109.0,
          -3887.0,
          1075.5
        ]
      ],
      "plane_distance": 1075.5
    }
  ],
  "tutorial_messages": []
}